<section class="h-screen flex flex-col">
  <div *ngIf="!modeTreeMonitor" class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
    <div class="container mt-0 flex-auto flex-col overflow-auto">
      <!-- Header -->
      <div class="overflow-auto flex-1 pb-6">
        <table class="min-w-500 !max-w-full w-full overflow-hidden" mat-table [dataSource]="dataSourceRoute" matSort
          #sortMainTable="matSort" matSortDisableClear multiTemplateDataRows>
          <ng-container matColumnDef="det">
            <th mat-header-cell *matHeaderCellDef ></th>
            <td *matCellDef="let row" >
              <div class="flex items-center w-full">
                <button class="h-7 min-h-7 leading-6 px-2" (click)="toggleDetails(row)">
                <mat-icon class="icon-size-5" [svgIcon]="
                    selectedMR?._id === row._id
                      ? 'heroicons_solid:chevron-up'
                      : 'heroicons_solid:chevron-down'
                  "></mat-icon>
              </button>
              </div>
            </td>
          </ng-container>

          <!-- Pin Column -->
          <ng-container matColumnDef="pin">
            <th mat-header-cell *matHeaderCellDef >
              <button mat-icon-button (click)="onPinHeaderClick($event)"
                [matTooltip]="'Configurar viajes pineados (' + pinnedTripIds.size + ' pineados)'"
                class="pin-header-button">
                <div class="relative">
                  <mat-icon class="icon-size-5" [style.color]="showOnlyPinned ? '#f59e0b' : '#6b7280'"
                    [style.transform]="showOnlyPinned ? 'rotate(45deg)' : 'none'">
                    push_pin
                  </mat-icon>
                  <span class="pin-counter" *ngIf="pinnedTripIds.size > 0">
                    {{pinnedTripIds.size}}
                  </span>
                </div>
              </button>
            </th>
            <td mat-cell *matCellDef="let row" >
              <!-- Solo mostrar el botón si la fila es un viaje real (tiene ID y no es un grupo) -->
              <ng-container *ngIf="row.id && !row.isStatusGroup && !row.isFunctionGroup">
                <button mat-icon-button [class.pin-button-active]="isTripPinned(row.id)"
                  (click)="onTogglePin(row, $event)"
                  [matTooltip]="isTripPinned(row.id) ? 'Despinear viaje' : 'Pinear viaje'">
                  <mat-icon class="icon-size-5" [style.transform]="isTripPinned(row.id) ? 'rotate(45deg)' : 'none'"
                    [style.color]="isTripPinned(row.id) ? '#f59e0b' : '#9ca3af'">
                    push_pin
                  </mat-icon>
                </button>
              </ng-container>
            </td>
          </ng-container>

          <!-- Viaje -->
          <ng-container matColumnDef="travel">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="default-padding">
              Viaje
            </th>
            <td *matCellDef="let data" class="default-padding !text-center">
               <div class="pr-4 w-full">
                 {{ data?.id }}
               </div>
            </td>
          </ng-container>

          <!-- Estado -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="default-padding">
              <p class="px-3">Estado</p>
            </th>
            <td mat-cell *matCellDef="let data" class="default-padding">
              <div >
                <app-trip-status-badge [statusTripId]="data?.statusTripId?.id"></app-trip-status-badge>
              </div>
            </td>
          </ng-container>

          <!-- Route -->
          <ng-container matColumnDef="route">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle">
              Ruta
            </th>
            <td mat-cell *matCellDef="let data" class="text-left first-col table-text text-sm">
              <p class="uppercase">
                <span class="table-text-code">{{
                  data?.subRoute?.externalKeys?.code
                  }}</span><br />
                {{ data?.subRoute.name }}
              </p>
            </td>
          </ng-container>

          <!-- Transportista -->
          <ng-container matColumnDef="user">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-left">
              Usuario
            </th>
            <td mat-cell *matCellDef="let data" class="text-left">
              <p class="uppercase text-sm">
                {{ data?.user?.user_login?.username ?? " - " }}
              </p>
            </td>
          </ng-container>

          <!-- Conductor -->
          <ng-container matColumnDef="businessPartner">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-left">
              Responsable
            </th>
            <td mat-cell *matCellDef="let data" class="text-left text-sm">
              <span class="table-text-code">{{
                data?.responsible?.externalKeys?.code
                }}</span><br />
              {{ data?.responsible?.name ?? "-" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="info">
            <th mat-header-cell *matHeaderCellDef mat-sort-header >
              <div class="flex justify-center w-full">
              Ruta - Usuario
              </div>
            </th>
            <td mat-cell *matCellDef="let element" class="text-sm leading-tight">
              <app-user-route-display [routeData]="{
                    routeName: element?.subRoute?.name ?? '-',
                    externalKeys: { code: element?.subRoute?.externalKeys?.code ?? '-' }
                  }" [userData]="{username: element?.user?.user_login?.username ?? element?.user ?? '-' }"
                [responsibleData]="{name: element?.responsible?.name ?? '-', personNumber: element?.responsible?.personNumber ?? '-', externalKeys: { code: element?.responsible?.externalKeys?.code ?? '-' }}"
                [displayMode]="'detailed'" [showRouteCode]="true" [showUser]="true" [showResponsible]="true">
              </app-user-route-display>
            </td>
          </ng-container>


          <!-- Vehiculo -->
          <ng-container matColumnDef="vehicle">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="default-padding" >
              Vehiculo
            </th>
            <td mat-cell *matCellDef="let data" class="default-padding text-sm">
             <div class="pr-4 text-center">
               <span class="table-text-code">{{ data?.vehicle?.plate }}</span><br />
              {{ data?.vehicle?.name ?? "-" }}
             </div>
            </td>
          </ng-container>

          <!-- Inicio -->
          <ng-container matColumnDef="start">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="default-padding">
              Inicio
            </th>
            <td mat-cell *matCellDef="let data" class="leading-tight default-padding text-sm">
              <p class="pr-2">
                <span class="font-semibold">T: </span>
                {{
                data?.dateHourStartTeoric
                ? (data.dateHourStartTeoric
                | date: "dd-MM-yyyy HH:mm")
                : "-"
                }}
              </p>
              <p class="pr-2 mt-2">
                <span class="font-semibold">R: </span>
                {{
                data?.dateHourStart
                ? (data.dateHourStart | date: "dd-MM-yyyy HH:mm")
                : "-"
                }}
              </p>
            </td>
          </ng-container>

          <!-- Fin -->
          <ng-container matColumnDef="end" >
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="default:">
              Fin
            </th>
            <td mat-cell *matCellDef="let data" class="text-left default-padding text-sm leading-tight">
              <p class="pr-2">
                <span class="font-semibold">T: </span>
                {{
                data?.dateHourEndTeoric
                ? (data.dateHourEndTeoric
                | date: "dd-MM-yyyy HH:mm")
                : "-"
                }}
              </p>
              <p class="pr-2 mt-2">
                <span class="font-semibold">R: </span>
                {{
                data?.dateHourEnd
                ? (data.dateHourEnd | date: "dd-MM-yyyy HH:mm")
                : "-"
                }}
              </p>
            </td>
          </ng-container>

          <!-- Pedidos -->
          <ng-container matColumnDef="documents">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-center">
              Documentos
            </th>
            <td mat-cell *matCellDef="let data" class="text-center text-sm">
              <p class="pr-2">{{ data?.quantity }}</p>
            </td>
          </ng-container>
          <ng-container matColumnDef="assignedLoad">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="default-padding">
              <div class="pl-5" >
                  Peso (<label>{{ loanUnit }}</label>)
              </div>
            </th>
            <td mat-cell *matCellDef="let data" class="text-center text-sm">
              <p class="pl-2">
                {{ data?.totalWeight?.value | number: "1.3-3" }}
              </p>
            </td>
          </ng-container>

          <!--  Nro. Paradas  -->
          <ng-container matColumnDef="noStops">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="default-padding">
              <p >Nro. Paradas</p>
            </th>
            <td mat-cell *matCellDef="let data" class="text-center text-sm">
              <p class="pr-5">{{ data?.stops ?? " - " }}</p>
            </td>
          </ng-container>

          <!-- Documentos de carga unificados -->
          <ng-container matColumnDef="hasUnifiedLoadDocs">
            <th mat-header-cell *matHeaderCellDef class="text-center">
              <div class="flex justify-center pr-5">
                <mat-icon svgIcon="heroicons_outline:document-duplicate"
                  class="text-gray-400" matTooltip="Documentos de carga unificados"></mat-icon>
              </div>
            </th>
            <td mat-cell *matCellDef="let data" class="text-center">
              <div class="flex justify-center pr-5">
                <app-unified-load-docs-chip [hasUnifiedLoadDocs]="data?.hasUnifiedLoadDocs"></app-unified-load-docs-chip>
              </div>
            </td>
          </ng-container>

           <!--  Monitoreo Tiempo Real  -->

          <ng-container matColumnDef="realTimeMonitor">
            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
            <td mat-cell *matCellDef="let data; let i = dataIndex" class="text-left no-padding-cell">
              <button class="pr-3" matTooltip="Monitor a tiempo real" (click)="openModalMonitor(data, i)">
                <mat-icon svgIcon="heroicons_outline:truck"></mat-icon>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let row" [attr.colspan]="displayColums.length">
              <ng-container *ngIf="selectedMR?._id === row?._id">
                <ng-container *ngTemplateOutlet="
                    rowDetailsTemplate;
                    context: { $implicit: row }
                  "></ng-container>
              </ng-container>
            </td>
          </ng-container>

          <!-- Acciones -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
            <td mat-cell *matCellDef="let row" class="px-6 py-3 text-left">
              <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #actionMenu="matMenu">
                <button mat-menu-item (click)="openEditModal(row)">
                  <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                  Editar
                </button>
                @if(row.isAvailableTripPurge){
                <button *ngIf="row.isTripCancelable" mat-menu-item (click)="openPurgeDialog(row)"
                  [disabled]="row.statusTripId?.id === tripStatus.FINALIZADO">
                  <mat-icon svgIcon="heroicons_outline:arrow-path"></mat-icon>
                  Purgar
                </button>
                }
                <button *ngIf="row.statusTripId.id !== 2 && row.statusTripId.id !== 3" mat-menu-item
                  (click)="openRefDownloadResumeModal(row.id)">
                  <mat-icon svgIcon="heroicons_outline:document-arrow-down"></mat-icon>
                  Descargar Resumen
                </button>
                <button *canPermissionsOnly="PERMISSIONS.ROUTE_MONITOR.AUDIT_LOG" mat-menu-item (click)="openTripAuditLog(row)">
                  <mat-icon>history</mat-icon>
                  Ver Bitácora
                </button>
              </mat-menu>
            </td>
          </ng-container>

          <!-- Header Row -->
          <tr mat-header-row *matHeaderRowDef="displayColums" class="sticky top-0 bg-white dark:bg-gray-900"></tr>

          <!-- Fila Principal -->
          <tr mat-row *matRowDef="let row; columns: displayColums" class="border-b"
            [class.table-expanded-row]="selectedMR?._id === row?._id"></tr>

          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="table-detail-row"></tr>
        </table>
        <div *ngIf="this.dataSourceRoute?.data?.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">
          Lo sentimos, no hay registros para mostrar.
        </div>
      </div>
    </div>
  </div>
  <!-- Tree view -->
  <div *ngIf="modeTreeMonitor" class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
    <div class="container mt-0 flex-auto flex-col overflow-auto">
      <div class="overflow-auto flex-1 pb-6">
        <table class="min-w-500 w-full overflow-y-auto" mat-table [dataSource]="dataSourceRouteTree" matSort
          #sortMainTable="matSort" matSortDisableClear multiTemplateDataRows>

          <!-- Columna det - En función muestra ruta-usuario, en estado solo botones -->
          <ng-container matColumnDef="det">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              <div class="flex items-center w-full">
                <!-- Botón de expansión para nodos padre -->
                <button mat-icon-button [style.visibility]="!hasChild(0, row) ? 'hidden' : ''"
                  [style.marginLeft.px]="getLevel(row) * 20" (click)="treeControl.toggle(row)">
                  <mat-icon color="primary">
                    {{treeControl.isExpanded(row) ? 'expand_more' : 'chevron_right'}}
                  </mat-icon>
                </button>
                <!-- Botón de detalles para nodos hijo -->
                <div *ngIf="!hasChild(0, row)">
                  <button class="h-7 min-h-7 leading-6 px-2" (click)="toggleDetails(row)">
                    <mat-icon class="icon-size-5" [svgIcon]="
                        selectedMR?._id === row._id 
                        ? 'heroicons_solid:chevron-up'
                        : 'heroicons_solid:chevron-down' 
                        "></mat-icon>
                  </button>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- Pin Column -->
          <ng-container matColumnDef="pin">
            <th mat-header-cell *matHeaderCellDef>
              <button mat-icon-button (click)="onPinHeaderClick($event)"
                [matTooltip]="'Configurar viajes pineados (' + pinnedTripIds.size + ' pineados)'"
                class="pin-header-button">
                <div class="relative">
                  <mat-icon class="icon-size-5" [style.color]="showOnlyPinned ? '#f59e0b' : '#6b7280'"
                    [style.transform]="showOnlyPinned ? 'rotate(45deg)' : 'none'">
                    push_pin
                  </mat-icon>
                  <span class="pin-counter" *ngIf="pinnedTripIds.size > 0">
                    {{pinnedTripIds.size}}
                  </span>
                </div>
              </button>
            </th>
            <td mat-cell *matCellDef="let row">
              <!-- Solo mostrar el botón si NO es un nodo padre (es decir, es un viaje real) -->
              <ng-container *ngIf="!hasChild(0, row)">
                <button mat-icon-button [class.pin-button-active]="isTripPinned(row.id)"
                  (click)="onTogglePin(row, $event)"
                  [matTooltip]="isTripPinned(row.id) ? 'Despinear viaje' : 'Pinear viaje'">
                  <mat-icon class="icon-size-5" [style.transform]="isTripPinned(row.id) ? 'rotate(45deg)' : 'none'"
                    [style.color]="isTripPinned(row.id) ? '#f59e0b' : '#9ca3af'">
                    push_pin
                  </mat-icon>
                </button>
              </ng-container>
            </td>
          </ng-container>

          <!-- Columna de viaje/estado/función -->
          <ng-container matColumnDef="travel">
            <th mat-header-cell *matHeaderCellDef class="default-padding" >
              Viaje
            </th>
            <td mat-cell *matCellDef="let row" class="default-padding">
                <div class="flex items-center gap-x-2" *ngIf="hasChild(0, row)" >
                  <app-trip-status-icon
                    *ngIf="modeTreeMonitor === 'statusTrip'"
                    [statusTripId]="row.auxUniqueStatus?.id"
                    size="sm">
                  </app-trip-status-icon>
                  <span class="font-bold text-sm">{{ getGroupName(row) }}</span>
                  <span class="text-sm text-gray-500 font-bold">({{ row.children?.length || 0 }})</span>
                </div>
                <ng-container *ngIf="!hasChild(0, row)">
                      {{ row.id }}
                </ng-container>
            </td>
          </ng-container>

          <!-- Estado (solo para vista árbol) -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef class="default-padding">
               <p class="px-3">Estado</p>
            </th>
            <td mat-cell *matCellDef="let row" class="default-padding">
              <div *ngIf="!hasChild(0, row)" >
                <app-trip-status-badge [statusTripId]="row?.statusTripId?.id"></app-trip-status-badge>
              </div>
            </td>
          </ng-container>
          <!-- Columna info -->
          <ng-container matColumnDef="info">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Ruta - Usuario
            </th>
            <td mat-cell *matCellDef="let element" class="text-sm leading-tight">
              <!-- Solo mostrar datos si no es nodo padre -->
             <app-user-route-display *ngIf="!hasChild(0, element)" [routeData]="{
                    routeName: element?.subRoute?.name ?? '-',
                    externalKeys: { code: element?.subRoute?.externalKeys?.code ?? '-' }
                  }" [userData]="{username: element?.user?.user_login?.username ?? element?.user ?? '-' }"
                [responsibleData]="{name: element?.responsible?.name ?? '-', personNumber: element?.responsible?.personNumber ?? '-', externalKeys: { code: element?.responsible?.externalKeys?.code ?? '-' }}"
                [displayMode]="'detailed'" [showRouteCode]="true" [showUser]="true" [showResponsible]="true">
              </app-user-route-display>
            </td>
          </ng-container>
          <!-- Vehiculo -->
          <ng-container matColumnDef="vehicle">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="default-padding">
              Vehiculo
            </th>
            <td mat-cell *matCellDef="let data" class="default-padding text-sm">
              <div *ngIf="!hasChild(0, data)" class="pr-4 text-center">
               <span class="table-text-code">{{ data?.vehicle?.plate }}</span><br />
              {{ data?.vehicle?.name ?? "-" }}
             </div>
            </td>
          </ng-container>
          <!-- Start -->
          <ng-container matColumnDef="start">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="default-padding">
              Inicio
            </th>
            <td mat-cell *matCellDef="let data" class="leading-tight default-padding text-sm">
              <ng-container *ngIf="!hasChild(0, data)" >
                <p class="pr-2">
                <span class="font-semibold">T: </span>
                {{
                data?.dateHourStartTeoric
                ? (data.dateHourStartTeoric
                | date: "dd-MM-yyyy HH:mm")
                : "-"
                }}
              </p>
              <p class="pr-2 mt-2">
                <span class="font-semibold">R: </span>
                {{
                data?.dateHourStart
                ? (data.dateHourStart | date: "dd-MM-yyyy HH:mm")
                : "-"
                }}
              </p>
              </ng-container>
            </td>
          </ng-container>
          <!-- End -->
          <ng-container matColumnDef="end" class="min-w-100">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="default-padding">
              Fin
            </th>
            <td mat-cell *matCellDef="let data" class="text-left text-sm leading-tight">
             <ng-container *ngIf="!hasChild(0, data)" >
                  <p  class="pr-2">
                <span class="font-semibold">T: </span>
                {{
                data?.dateHourEndTeoric
                ? (data.dateHourEndTeoric
                | date: "dd-MM-yyyy HH:mm")
                : "-"
                }}
              </p>
              <p class="pr-2 mt-2">
                <span class="font-semibold">R: </span>
                {{
                data?.dateHourEnd
                ? (data.dateHourEnd | date: "dd-MM-yyyy HH:mm")
                : "-"
                }}
              </p>
             </ng-container>
            </td>
          </ng-container>
          <!-- Documents -->
          <ng-container matColumnDef="documents">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-center">
              Documentos
            </th>
            <td mat-cell *matCellDef="let data" class="text-center text-sm">
              <p *ngIf="!hasChild(0, data)" class="pr-2">{{ data?.quantity }}</p>
            </td>
          </ng-container>
          <ng-container matColumnDef="assignedLoad">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="default-padding">
              <div class="pl-5" >
                  Peso (<label>{{ loanUnit }}</label>)
              </div>
            </th>
            <td mat-cell *matCellDef="let data" class="text-center text-sm">
               <p *ngIf="!hasChild(0, data)" class="pl-2">
                {{ data?.totalWeight?.value | number: "1.3-3" }}
              </p>
            </td>
          </ng-container>
          <!-- Nro. Paradas -->
          <ng-container matColumnDef="noStops">
           <th mat-header-cell mat-sort-header *matHeaderCellDef class="default-padding">
              <p >Nro. Paradas</p>
            </th>
            <td mat-cell *matCellDef="let data" class="text-center text-sm">
                <p *ngIf="!hasChild(0, data)" class="pr-5">{{ data?.stops ?? " - " }}</p>
            </td>
          </ng-container>
          <!-- Documentos de carga unificados -->
          <ng-container matColumnDef="hasUnifiedLoadDocs">
            <th mat-header-cell *matHeaderCellDef class="text-center">
              <div class="flex justify-center pr-5">
                <mat-icon svgIcon="heroicons_outline:document-duplicate"
                  class="text-gray-400" matTooltip="Documentos de carga unificados"></mat-icon>
              </div>
            </th>
            <td mat-cell *matCellDef="let data" class="text-center">
              <div class="flex justify-center pr-5">
                <app-unified-load-docs-chip *ngIf="!hasChild(0, data)"
                  [hasUnifiedLoadDocs]="data?.hasUnifiedLoadDocs"></app-unified-load-docs-chip>
              </div>
            </td>
          </ng-container>
           <!-- Monitoreo Tiempo Real -->
          <ng-container matColumnDef="realTimeMonitor">
            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
            <td mat-cell *matCellDef="let data; let i = dataIndex" class="text-left no-padding-cell">
              <div *ngIf="!hasChild(0, data)">
                <button class="pr-3" matTooltip="Monitor a tiempo real" (click)="openModalMonitor(data, i)">
                  <mat-icon svgIcon="heroicons_outline:truck"></mat-icon>
                </button>
              </div>
            </td>
          </ng-container>
          <!-- Actions -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
            <td mat-cell *matCellDef="let row" class="px-6 py-3 text-left">
              <div *ngIf="!hasChild(0, row)">
                <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #actionMenu="matMenu">
                  <button mat-menu-item (click)="openEditModal(row)">
                    <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                    Editar
                  </button>
                  <button *canPermissionsOnly="PERMISSIONS.ROUTE_MONITOR.AUDIT_LOG" mat-menu-item (click)="openTripAuditLog(row)">
                    <mat-icon>history</mat-icon>
                    Ver Bitácora
                  </button>
                </mat-menu>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let row" [attr.colspan]="displayColums.length">
              <ng-container *ngIf="!hasChild(0, row) && selectedMR?._id === row?._id">
                <ng-container *ngTemplateOutlet="
                    rowDetailsTemplate;
                    context: { $implicit: row }
                  ">
                </ng-container>
              </ng-container>
            </td>
          </ng-container>
          <!-- Fila de detalles expandidos -->
          <!-- Header Row -->
          <tr mat-header-row *matHeaderRowDef="displayColumsTree" class="sticky top-0 bg-white dark:bg-gray-900">
          </tr>
          <!-- Fila Principal -->
          <tr mat-row *matRowDef="let row; columns: displayColumsTree" class="border-b"
            [class.table-expanded-row]="selectedMR?._id === row?._id" [class.font-bold]="hasChild(0, row)"
            [class.bg-gray-50]="hasChild(0, row) && modeTreeMonitor === 'statusTrip'"
            [class.bg-blue-50]="hasChild(0, row) && modeTreeMonitor === 'functionTrip'"
            [class.dark:bg-gray-900]="hasChild(0, row) && modeTreeMonitor === 'statusTrip'"
            [class.dark:bg-blue-900]="hasChild(0, row) && modeTreeMonitor === 'functionTrip'"></tr>
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="table-detail-row"></tr>
        </table>
        <div *ngIf="this.dataSourceRouteTree?.data?.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">
          Lo sentimos, no hay registros para mostrar.
        </div>
      </div>
    </div>
  </div>
  <!-- Paginación *ngIf="!modeTreeMonitor"  -->
  <div *ngIf="!modeTreeMonitor" class="sticky bottom-0 z-50 bg-white dark:bg-gray-900 border-t">
    <mat-paginator  [pageSizeOptions]="[10, 50, 100, 150]" showFirstLastButtons [length]="totalItems"
      [pageSize]="pageSize" (page)="onPageChange($event)"></mat-paginator>
  </div>
  <!-- Datos de Carga y Documentos -->
  <ng-template #rowDetailsTemplate>
    <div class="overflow-hidden mx-auto"
         [ngClass]="{
           'max-w-[calc(100vw-350px)] 2xl:max-w-[calc(100vw-350px)]': isNavOpened,
           'max-w-[calc(100vw-80px)] 2xl:max-w-[calc(100vw-80px)]': !isNavOpened
         }">
      <mat-tab-group (selectedTabChange)="onParentTabChange($event)">
        <mat-tab>
          <ng-template mat-tab-label>
            <div class="flex flex-row items-center gap-2">
              <mat-icon class="w-6 h-6 text-amber-500" svgIcon="heroicons_solid:archive-box"
                [matMenuTriggerFor]="actionMenuInfo" [ngClass]="
                  statusDocumentCharge.notSynchronization > 0
                    ? 'badge-red'
                    : statusDocumentCharge.loadSynchronization > 0
                      ? 'badge-amber'
                      : 'badge-green'
                " [matBadge]="this.statusDocumentCharge?.countDocument"></mat-icon>
              <mat-menu #actionMenuInfo="matMenu">
                <div class="w-60 p-3 flex flex-col gap-3">
                  <div class="flex flex-row">
                    <div
                      class="cursor-pointer w-6 h-6 p-2 mr-3 rounded-full bg-red-500 text-white flex items-center justify-center shadow-md text-sm">
                      {{ statusDocumentCharge.notSynchronization || 0 }}
                    </div>
                    <span matBadgeColor="warn" matBadgeOverlap="false" class="inline-block">
                      No sincronizados
                    </span>
                  </div>

                  <div class="flex flex-row">
                    <div
                      class="cursor-pointer w-6 h-6 p-2 mr-3 rounded-full bg-amber-500 text-white flex items-center justify-center shadow-md text-sm">
                      {{ statusDocumentCharge.loadSynchronization || 0 }}
                    </div>
                    <span matBadgeColor="warn" matBadgeOverlap="false" class="inline-block">
                      Sincronizar pendientes
                    </span>
                  </div>
                  <!--
        <p>
                    <span
                      [matBadge]="statusDocument.loadSynchronization"
                      matBadgeColor="warn"
                      matBadgeOverlap="false"
                      class="inline-block badge-amarillo"
                    >
                      Sincronizar Pendientes
                    </span>
                  </p>             
                       
                  -->

                  <div class="flex flex-row">
                    <div
                      class="cursor-pointer w-6 h-6 p-2 mr-3 rounded-full bg-green-500 text-white flex items-center justify-center shadow-md text-sm">
                      {{ statusDocumentCharge.synchronization || 0 }}
                    </div>
                    <span matBadgeColor="warn" matBadgeOverlap="false" class="inline-block">
                      Sincronizados
                    </span>
                  </div>
                </div>
              </mat-menu>
              <span>Documentos de carga</span>
            </div>
          </ng-template>

          <!-- Panel de métricas -->
          <div>
            <div *ngIf="isVisibleLoan" class="px-4 pt-4 bg-gray-100 rounded-lg shadow-md">
              <div class="grid grid-cols-5 gap-4">

                <div class="p-4 bg-white shadow-md rounded-lg text-center">
                  <div class="flex flex-row items-center justify-center">
                    <button mat-button color="primary"
                      (click)="openDocumentsMapWindow(monitorDocumentTypeEnum.DOCUMENT)" matTooltip="Ver mapa">
                      <!--[disabled]="!selectedVisits?.length"-->
                      <mat-icon [svgIcon]="'heroicons_outline:map-pin'"></mat-icon>
                    </button>

                    @if(!isNew){
                    <app-monitor-map [title]="'Documentos de Carga'"
                      [isOpen]="(windowState.documentsWindow.isOpen$ | async) && userRequestedMap"
                      [windowType]="'documents'">
                      <app-agenda-map *ngIf="(windowState.documentsWindow.isOpen$ | async) && userRequestedMap"
                        [visits]="selectedVisits" #agendaMap>
                      </app-agenda-map>
                    </app-monitor-map>
                    }
                  </div>
                </div>

                <div class="p-4 bg-white shadow-md rounded-lg text-center">
                  <div class="flex flex-row items-center justify-center">
                    <p class="text-gray-600 font-medium">
                      Cantidad de Documentos
                    </p>
                    <mat-icon matTooltip="Recargar" svgIcon="heroicons_solid:arrow-path"
                      class="w-6 h-6 text-stale-500 ml-4 cursor-pointer"></mat-icon>
                  </div>
                  <p class="text-2xl font-bold text-blue-500">
                    {{ statusDocumentCharge.countDocument }}
                  </p>
                </div>

                <div class="p-4 bg-white shadow-md rounded-lg text-center">
                  <p class="text-gray-600 font-medium">No se Sincronizan</p>
                  <p class="text-2xl font-bold text-purple-400">
                    {{ statusDocumentCharge.notSynchronization }}
                  </p>
                </div>

                <div class="p-4 bg-white shadow-md rounded-lg text-center">
                  <div class="flex flex-row items-center justify-center">
                    <p class="text-gray-600 font-medium">Por Sincronizar</p>
                    <mat-icon [matMenuTriggerFor]="actionMenuSincronizar" matTooltip="Sincronizar"
                      svgIcon="heroicons_solid:arrow-path"
                      class="w-6 h-6 text-stale-500 ml-4 cursor-pointer"></mat-icon>
                  </div>
                  <p class="text-2xl font-bold text-yellow-500">
                    {{ statusDocumentCharge.loadSynchronization }}
                  </p>
                  <!-- Despplegable soncronizar -->

                  <mat-menu #actionMenuSincronizar="matMenu">
                    <button (click)="
                        synchronizeOrders(dataSourceOrderLoan.data, DocumentTypeEnum.DOCUMENTO_DE_CARGA)
                      " mat-menu-item>
                      <mat-icon [matBadge]="
                          statusDocumentCharge.notSynchronization +
                          statusDocumentCharge.loadSynchronization
                        ">sync</mat-icon>
                      <label> Sincronizar Todo</label>
                    </button>
                    <button (click)="
                        synchronizeOrders(dataSourceOrderLoan.data, DocumentTypeEnum.DOCUMENTO_DE_CARGA)
                      " mat-menu-item>
                      <mat-icon [matBadge]="statusDocumentCharge.notSynchronization"
                        svgIcon="heroicons_outline:arrow-path"></mat-icon>
                      Volver a Sincronizar
                    </button>
                    <button (click)="
                        synchronizeOrders(dataSourceOrderLoan.data, DocumentTypeEnum.DOCUMENTO_DE_CARGA)
                      " mat-menu-item>
                      <mat-icon [matBadge]="statusDocumentCharge.loadSynchronization"
                        svgIcon="heroicons_outline:clock"></mat-icon>
                      Sincronizar Pendientes
                    </button>
                  </mat-menu>
                </div>

                <div class="p-4 bg-white shadow-md rounded-lg text-center">
                  <p class="text-gray-600 font-medium">Sincronizados</p>
                  <p class="text-2xl font-bold text-green-500">
                    {{ statusDocumentCharge.synchronization }}
                  </p>
                </div>
              </div>

              <div class="flex justify-end mt-4">
                <button (click)="onDetailsLoan()" class="px-8 bg-white shadow-md rounded-t-lg h-6">
                  <mat-icon svgIcon="heroicons_solid:chevron-up" class="text-xs"></mat-icon>
                </button>
              </div>
            </div>
            <ng-container *ngIf="!isVisibleLoan">
              <div class="flex justify-end">
                <button (click)="onDetailsLoan()" class="px-8 bg-white shadow-md rounded-b-lg h-6">
                  <mat-icon svgIcon="heroicons_solid:chevron-down" class="text-xs"></mat-icon>
                </button>
              </div>
            </ng-container>
          </div>

          <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="setActiveTable('charge')"
            class="scroll">
            <mat-tab label="Pedidos">
              <!-- Datos pedidos -->
              <app-table-load-list-smart-grid [summaryData]="dataSourceOrderLoan.data"
                [totalItems]="dataSourceOrderLoan?.pageInfo?.[0]?.total" [pageSize]="pageSizeLoan"
                [currentPage]="currentPage" [UMPActive]="UMPActive" [canJoin]="true"
                (pageChanged)="onPageChangeOrderLoan($event)" (refreshMonitor)="onDataLoan()" [canEdit]="true"
                [canRelease]="selectedMR?.statusTripId?.id == tripStatus.ABIERTO || selectedMR?.statusTripId?.id == tripStatus.CARGANDO"></app-table-load-list-smart-grid>
            </mat-tab>
            <mat-tab label="Resumen Material">
              <!-- Tabla -->
              <div class="w-full bg-white m-0 pb-4">
                <app-summary-material [type]="DocumentTypeEnum.DOCUMENTO_DE_CARGA"
                  [summaryData]="dataSourceChargeMaterials.data"
                  [totalRecords]="chargeTotalItems"
                  [UMPActive]="UMPActive"
                  [isAllColumns]="isAllColumns"
                  (refreshMonitor)="onDataLoan()"></app-summary-material>
              </div>
            </mat-tab>

            <mat-tab label="Pedidos por cliente">
              <div class="flex flex-col flex-1 mb-40">

                <ng-container *ngIf="activeTable === 'charge'" [ngTemplateOutlet]="tableMainCharge"
                  [ngTemplateOutletContext]="{
                    charge: dataSourceChargePartners,
                    exportFn: exportChargeToExcel
                  }">
                </ng-container>

                <div *ngIf="this.dataSourceChargePartners.data.length === 0"
                  class="border-t p-8 text-center text-1xl sm:p-10">
                  Lo sentimos, no hay registros para mostrar.
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <div class="flex flex-row items-center gap-2">
              <mat-icon class="w-6 h-6 text-violet-500" [ngClass]="
                  statusDocumentDelivery.notDelivered > 0
                    ? 'badge-red'
                    : statusDocumentDelivery.loadDelivered > 0
                      ? 'badge-amber'
                      : 'badge-greeen'
                " [matMenuTriggerFor]="actionMenuInfo"
                [matBadge]="this.statusDocumentDelivery?.countDocument">local_shipping</mat-icon>

              <mat-menu #actionMenuInfo="matMenu">
                <div class="w-50 p-3 flex flex-col gap-3">
                  <div class="flex flex-row">
                    <div
                      class="cursor-pointer w-6 h-6 p-2 mr-3 rounded-full bg-red-500 text-white flex items-center justify-center shadow-md text-sm">
                      {{ statusDocumentDelivery.notDelivered || 0 }}
                    </div>
                    <span matBadgeColor="warn" matBadgeOverlap="false" class="inline-block">
                      Rechazadas
                    </span>
                  </div>

                  <div class="flex flex-row">
                    <div
                      class="cursor-pointer w-6 h-6 p-2 mr-3 rounded-full bg-amber-500 text-white flex items-center justify-center shadow-md text-sm">
                      {{ statusDocumentDelivery.loadDelivered || 0 }}
                    </div>
                    <span matBadgeColor="warn" matBadgeOverlap="false" class="inline-block">
                      Pendientes
                    </span>
                  </div>
                  <div class="flex flex-row">
                    <div
                      class="cursor-pointer w-6 h-6 p-2 mr-3 rounded-full bg-green-500 text-white flex items-center justify-center shadow-md text-sm">
                      {{ statusDocumentDelivery.delivered || 0 }}
                    </div>
                    <span matBadgeColor="warn" matBadgeOverlap="false" class="inline-block">
                      Entregados
                    </span>
                  </div>
                </div>
              </mat-menu>
              <span>Carga</span>
              <mat-icon *ngIf="this.deliveryUnified > 0" class="text-amber-500 text-md"
                svgIcon="heroicons_outline:exclamation-triangle" (click)="loadMaterilaUnified(this.selectedMR?.id)"
                matTooltip="Confirmar entregas"></mat-icon>
            </div>
          </ng-template>

          <div *ngIf="isVisibleDelivery" class="px-4 pt-4 bg-gray-100 rounded-lg shadow-md">
            <div class="grid grid-cols-5 gap-4">

              <div class="p-4 bg-white shadow-md rounded-lg text-center">
                <div class="flex flex-row items-center justify-center">
                  <button mat-button color="primary" (click)="openDocumentsMapWindow(monitorDocumentTypeEnum.DELIVERY)"
                    matTooltip="Ver mapa">
                    <mat-icon [svgIcon]="'heroicons_outline:map-pin'"></mat-icon>
                  </button>

                  @if(!isNew){
                  <app-monitor-map [title]="'Entregas'"
                    [isOpen]="(windowState.deliveriesWindow.isOpen$ | async) && userRequestedMap"
                    [windowType]="'deliveries'">
                    <app-agenda-map *ngIf="(windowState.deliveriesWindow.isOpen$ | async) && userRequestedMap"
                      [visits]="selectedDelivery" #agendaMap>
                    </app-agenda-map>
                  </app-monitor-map>
                  }
                </div>
              </div>

              <div class="p-4 bg-white shadow-md rounded-lg text-center">
                <div class="flex flex-row items-center justify-center">
                  <p class="text-gray-600 font-medium">
                    Cantidad de Documentos
                  </p>
                  <!-- <mat-icon matTooltip="Recargar" svgIcon="heroicons_solid:arrow-path"
                    class="w-6 h-6 text-stale-500 ml-4 cursor-pointer"></mat-icon> -->
                </div>
                <p class="text-2xl font-bold text-blue-500">
                  {{ statusDocumentDelivery.countDocument }}
                </p>
              </div>

              <div class="p-4 bg-white shadow-md rounded-lg text-center">
                <p class="text-gray-600 font-medium">No entregados</p>
                <p class="text-2xl font-bold text-purple-400">
                  {{ statusDocumentDelivery.notDelivered }}
                </p>
              </div>

              <div class="p-4 bg-white shadow-md rounded-lg text-center">
                <p class="text-gray-600 font-medium">Entregados</p>
                <p class="text-2xl font-bold text-green-500">
                  {{ statusDocumentDelivery.delivered }}
                </p>
              </div>

              <div class="p-4 bg-white shadow-md rounded-lg text-center">
                <p class="text-gray-600 font-medium">Por entregar</p>
                <p class="text-2xl font-bold text-green-500">
                  {{ statusDocumentDelivery.loadDelivered }}
                </p>
              </div>
            </div>

            <div class="flex justify-end mt-4">
              <button (click)="onDetailsDelivery()" class="px-8 bg-white shadow-md rounded-t-lg h-6">
                <mat-icon svgIcon="heroicons_solid:chevron-up" class="text-xs"></mat-icon>
              </button>
            </div>
          </div>
          <ng-container *ngIf="!isVisibleDelivery">
            <div class="flex justify-end mb-2">
              <button (click)="onDetailsDelivery()" class="px-8 bg-white shadow-md rounded-b-lg h-6">
                <mat-icon svgIcon="heroicons_solid:chevron-down" class="text-xs"></mat-icon>
              </button>
            </div>
          </ng-container>

          <mat-tab-group [(selectedIndex)]="subTabActiveIndex" (selectedTabChange)="onSubTabsChange($event)"
            class="scroll">
            <mat-tab label="Transporte">
              <!-- Documento de Transporte -->
              <app-transport-load-list [summaryData]="dataSourceTransport.data"
                [totalItems]="dataSourceTransport?.pageInfo?.[0]?.total" [pageSize]="pageSizeLoan" [trip]="selectedMR"
                [UMPActive]="UMPActive" [currentPage]="currentPage" (refreshMonitor)="onDataRefreshedTransport()"
                (pageChanged)="onPageChangeTrasport($event)"></app-transport-load-list>
            </mat-tab>
            <mat-tab label="Entregas">
              <!-- Datos pedidos -->
              <app-table-load-list-smart-grid [summaryData]="dataSourceDeliveryLoan?.data ?? []"
                [totalItems]="dataSourceDeliveryLoan?.pageInfo?.[0]?.total" [pageSize]="pageSizeLoan"
                [currentPage]="currentPage" [isAllColumnsTransport]="true" [UMPActive]="UMPActive"
                [batchesDetail]="true" (refreshMonitor)="onDataRefreshed()"
                (pageChanged)="onPageChangeData($event)"></app-table-load-list-smart-grid>
            </mat-tab>
            <mat-tab label="Resumen Material">
              <div class="w-full bg-white m-0 pb-4">
                <app-summary-material [type]="DocumentTypeEnum.ENTREGA_SALIDA"
                  [materialClientDetailsForExport]="materialClientDetails"
                  [summaryData]="dataSourceDeliveryMaterials.data"
                  [totalRecords]="deliveryTotalItems"
                  [UMPActive]="UMPActive"
                  [isAllColumns]="isAllColumns"
                  (refreshMonitor)="onDataRefreshed()"></app-summary-material>
              </div>
            </mat-tab>

            <mat-tab label="Entregas por cliente">
              <div class="mb-40">

                <ng-container *ngIf="activeTable === 'delivery'" [ngTemplateOutlet]="tableMainCharge"
                  [ngTemplateOutletContext]="{
                    charge: dataSourceDeliveryPartners,
                    exportFn: exportDeliveryToExcel
                  }">
                </ng-container>

                <div *ngIf="this.dataSourceDeliveryPartners.data.length === 0"
                  class="border-t p-8 text-center text-1xl sm:p-10">
                  Lo sentimos, no hay registros para mostrar.
                </div>
                <!-- </div> -->
              </div>
            </mat-tab>

            <mat-tab label="Materiales por cliente">
              <div *ngIf="subTabActiveIndex === 4" class="mb-20">

                <app-monitor-client-material-summary *ngIf="subTabActiveIndex === 4"
                  [clientMaterials]="clientMaterialsSummary"
                  [groupedMaterialsWithCustomers]="groupedMaterialsWithCustomers" [UMPActive]="UMPActive"
                  [totalItems]="totalItemsClientMaterials" [pageSize]="pageSizeClientMaterials"
                  [pageIndex]="pageIndexClientMaterials" [isLoading]="isLoadingClientMaterials"
                  (initPage)="onClientMaterialsPageChange()" [tripId]="selectedMR?.id"
                  [documentTypes]="documentTypesForClientsGroupedByMaterial"
                  (pageChanged)="onClientMaterialsPageChange($event)">
                </app-monitor-client-material-summary>

                <div *ngIf="this.groupedMaterialsWithCustomers.length === 0"
                  class="border-t p-8 text-center text-1xl sm:p-10">
                  Lo sentimos, no hay registros para mostrar.
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <div class="flex flex-row items-center gap-2">
              <mat-icon svgIcon="heroicons_solid:document" class="w-6 h-6 text-stale-500" [ngClass]="
                  statusDocument.notSynchronization > 0
                    ? 'badge-red'
                    : statusDocument.loadSynchronization > 0
                      ? 'badge-amber'
                      : 'badge-greeen'
                " [matMenuTriggerFor]="actionMenuInfo" [matBadge]="statusDocument.countDocument"></mat-icon>
              <mat-menu #actionMenuInfo="matMenu">
                <div class="w-60 p-3 flex flex-col gap-3">
                  <div class="flex flex-row">
                    <div
                      class="cursor-pointer w-6 h-6 p-2 mr-3 rounded-full bg-red-500 text-white flex items-center justify-center shadow-md text-sm">
                      {{ statusDocument.notSynchronization || 0 }}
                    </div>
                    <span matBadgeColor="warn" matBadgeOverlap="false" class="inline-block">
                      No sincronizados
                    </span>
                  </div>

                  <div class="flex flex-row">
                    <div
                      class="cursor-pointer w-6 h-6 p-2 mr-3 rounded-full bg-amber-500 text-white flex items-center justify-center shadow-md text-sm">
                      {{ statusDocument.loadSynchronization || 0 }}
                    </div>
                    <span matBadgeColor="warn" matBadgeOverlap="false" class="inline-block">
                      Sincronizar pendientes
                    </span>
                  </div>

                  <div class="flex flex-row">
                    <div
                      class="cursor-pointer w-6 h-6 p-2 mr-3 rounded-full bg-green-500 text-white flex items-center justify-center shadow-md text-sm">
                      {{ statusDocument.synchronization || 0 }}
                    </div>
                    <span matBadgeColor="warn" matBadgeOverlap="false" class="inline-block">
                      Sincronizados
                    </span>
                  </div>
                </div>
              </mat-menu>
              <span>Trabajo en Curso</span>
            </div>
          </ng-template>

          <!-- Panel de métricas -->
          <div *ngIf="isVisibleDetailsDoc" class="px-4 pt-4 bg-gray-100 rounded-lg shadow-md">
            <div class="grid grid-cols-5 gap-4">
              <div class="p-4 bg-white shadow-md rounded-lg text-center">
                <div class="flex flex-row items-center justify-center">
                  <button mat-button color="primary" (click)="openDocumentsMapWindow(monitorDocumentTypeEnum.PROGRESS)"
                    matTooltip="Ver mapa">
                    <mat-icon [svgIcon]="'heroicons_outline:map-pin'"></mat-icon>
                  </button>
                </div>
              </div>

              <div class="p-4 bg-white shadow-md rounded-lg text-center">
                <div class="flex flex-row items-center justify-center">
                  <p class="text-gray-600 font-medium">
                    Cantidad de Documentos
                  </p>
                  <mat-icon matTooltip="Recargar" svgIcon="heroicons_solid:arrow-path"
                    class="w-6 h-6 text-stale-500 ml-4 cursor-pointer"></mat-icon>
                </div>
                <p class="text-2xl font-bold text-blue-500">
                  {{ statusDocument.countDocument }}
                </p>
              </div>

              <div class="p-4 bg-white shadow-md rounded-lg text-center">
                <p class="text-gray-600 font-medium">No se Sincronizan</p>
                <p class="text-2xl font-bold text-purple-400">
                  {{ statusDocument.notAllowedSync }}
                </p>
              </div>

              <div class="p-4 bg-white shadow-md rounded-lg text-center">
                <div class="flex flex-row items-center justify-center">
                  <p class="text-gray-600 font-medium">Por Sincronizar</p>
                  <mat-icon [matMenuTriggerFor]="actionMenuSincronizar" matTooltip="Sincronizar"
                    svgIcon="heroicons_solid:arrow-path" class="w-6 h-6 text-stale-500 ml-4 cursor-pointer"></mat-icon>
                </div>
                <p class="text-2xl font-bold text-yellow-500">
                  {{
                  statusDocument.notSynchronization +
                  statusDocument.loadSynchronization
                  }}
                </p>
                <!-- Despplegable soncronizar -->

                <mat-menu #actionMenuSincronizar="matMenu">
                  <button mat-menu-item (click)="synchronizeOrdersIn(groupDocuments)">
                    <mat-icon [matBadge]="
                        statusDocument.notSynchronization +
                        statusDocument.loadSynchronization
                      ">sync</mat-icon>
                    <label> Sincronizar Todo</label>
                  </button>
                  <button mat-menu-item>
                    <mat-icon [matBadge]="statusDocument.notSynchronization"
                      svgIcon="heroicons_outline:arrow-path"></mat-icon>
                    Volver a Sincronizar
                  </button>
                  <button mat-menu-item>
                    <mat-icon [matBadge]="statusDocument.loadSynchronization"
                      svgIcon="heroicons_outline:clock"></mat-icon>
                    Sincronizar Pendientes
                  </button>
                </mat-menu>
              </div>

              <div class="p-4 bg-white shadow-md rounded-lg text-center">
                <p class="text-gray-600 font-medium">Sincronizados</p>
                <p class="text-2xl font-bold text-green-500">
                  {{ statusDocument.synchronization }}
                </p>
              </div>
            </div>

            <div class="flex justify-end mt-4">
              <button (click)="onDetailsDocuemnt()" class="px-8 bg-white shadow-md rounded-t-lg h-6">
                <mat-icon svgIcon="heroicons_solid:chevron-up" class="text-xs"></mat-icon>
              </button>
            </div>
          </div>
          <ng-container *ngIf="!isVisibleDetailsDoc">
            <div class="flex justify-end mb-2">
              <button (click)="onDetailsDocuemnt()" class="px-8 bg-white shadow-md rounded-b-lg h-6">
                <mat-icon svgIcon="heroicons_solid:chevron-down" class="text-xs"></mat-icon>
              </button>
            </div>
          </ng-container>

          <mat-tab-group [(selectedIndex)]="workInProgressSubTabsIndex"
            (selectedTabChange)="onWorkProgressTabChange($event)" class="p-4 scroll">
            <mat-tab label="Documentos" class="scroll">
              <div *ngFor="let document of groupDocuments" class="mx-4">
                <div *ngIf="document?.items?.data?.length > 0"
                  class="flex gap-6 items-center justify-between p-4 border mt-4 border-gray-200 rounded-lg shadow-sm cursor-pointer hover:bg-gray-100"
                  (click)="toggleItemGroup(document)">
                  <div class="flex items-center space-x-2">
                    <span class="font-semibold text-gray-900">{{
                      document?.name
                      }}</span>
                    <div
                      class="cursor-pointer p-2 w-min h-6 rounded-full text-white flex items-center justify-center shadow-md transition text-xs"
                      [ngClass]="
                        getCountByStatus(document?.counts, 'notSynchronized') >
                        0
                          ? 'bg-red-500'
                          : getCountByStatus(
                                document?.counts,
                                'toSynchronized'
                              ) > 0
                            ? 'bg-amber-500 text-white'
                            : 'bg-green-500'
                      " [matMenuTriggerFor]="actionMenuInfo">
                      {{ getTotalCount(document?.counts) }}
                    </div>

                    <mat-menu #actionMenuInfo="matMenu">
                      <div class="w-60 p-3 flex flex-col gap-3">
                        <div class="flex flex-row">
                          <div
                            class="cursor-pointer w-6 h-6 p-2 mr-3 rounded-full bg-red-500 text-white flex items-center justify-center shadow-md text-sm">
                            {{
                            getCountByStatus(
                            document?.counts,
                            "notSynchronized"
                            ) || 0
                            }}
                          </div>
                          <span matBadgeColor="warn" matBadgeOverlap="false" class="inline-block">
                            No sincronizados
                          </span>
                        </div>

                        <div class="flex flex-row">
                          <div
                            class="cursor-pointer w-6 h-6 p-2 mr-3 rounded-full bg-amber-500 text-white flex items-center justify-center shadow-md text-sm">
                            {{
                            getCountByStatus(
                            document?.counts,
                            "toSynchronized"
                            ) || 0
                            }}
                          </div>
                          <span matBadgeColor="warn" matBadgeOverlap="false" class="inline-block">
                            Sincronizar pendientes
                          </span>
                        </div>

                        <div class="flex flex-row">
                          <div
                            class="cursor-pointer w-6 h-6 p-2 mr-3 rounded-full bg-green-500 text-white flex items-center justify-center shadow-md text-sm">
                            {{
                            getCountByStatus(
                            document?.counts,
                            "Synchronized"
                            ) || 0
                            }}
                          </div>
                          <span matBadgeColor="warn" matBadgeOverlap="false" class="inline-block">
                            Sincronizados
                          </span>
                        </div>
                      </div>
                    </mat-menu>
                  </div>

                  <mat-icon [svgIcon]="
                      selectDocumentGroup?.typeCode === document?.typeCode
                        ? 'heroicons_outline:chevron-up'
                        : 'heroicons_outline:chevron-down'
                    "></mat-icon>
                </div>

                <!-- Subfila (Detalles) -->
                <div *ngIf="selectDocumentGroup?.typeCode === document?.typeCode" class="pt-4">
                  <ng-container [ngSwitch]="document?.typeCode">
                    <!-- Caso DT005 (Facturas con pagos relacionados) -->
                    <app-table-load-list-smart-grid *ngSwitchCase="DocumentTypeEnum.FACTURA" [summaryData]="document.items?.data"
                      [totalItems]="document.items?.pageInfo?.[0]?.total" [pageSize]="pageSizeLoan"
                      [currentPage]="currentPage" (pageChanged)="onPageChangeGeneral($event)" [batchesDetail]="true"
                      [UMPActive]="UMPActive" [isFact]="true" (refreshMonitor)="onDataRefreshed()">
                    </app-table-load-list-smart-grid>
                    <!-- [relatedPayments]="getRelatedPayments(document)" -->

                    <app-table-load-list-smart-grid *ngSwitchCase="DocumentTypeEnum.DOCUMENTO_MERMA" [summaryData]="document.items?.data"
                      [totalItems]="document.items?.pageInfo?.[0]?.total" [pageSize]="pageSizeLoan"
                      [currentPage]="currentPage" (pageChanged)="onPageChangeGeneral($event)" [batchesDetail]="true"
                      [isAllColumnsMerma]="true" [UMPActive]="UMPActive" (refreshMonitor)="onDataRefreshed()">
                    </app-table-load-list-smart-grid>

                    <!-- Caso DT008 (Pagos) -->
                    <app-payment-load-list *ngSwitchCase="DocumentTypeEnum.DOCUMENTO_DE_PAGO" [summaryData]="document?.items.data"
                      [totalItems]="document?.items.pageInfo?.[0]?.total" [UMPActive]="UMPActive"
                      [isAllColumns]="isAllColumns" [currency]="currency" (pageChanged)="onPageChangeGeneral($event)"
                      (refreshMonitor)="onDataRefreshed()">
                    </app-payment-load-list>

                    <!-- Caso por defecto (otros documentos) -->
                    <app-table-load-list-smart-grid *ngSwitchDefault [summaryData]="document?.items?.data"
                      [totalItems]="document?.items?.pageInfo?.[0]?.total" [pageSize]="pageSizeLoan"
                      [currentPage]="currentPage" (pageChanged)="onPageChangeGeneral($event)" [UMPActive]="UMPActive"
                      [isFact]="false" [batchesDetail]="
                        [DocumentTypeEnum.SOLICITUD_CAMBIO_PRODUCTO, DocumentTypeEnum.SOLICITUD_DEVOLUCION_PRODUCTO, DocumentTypeEnum.CAMBIO_DE_PRODUCTO, DocumentTypeEnum.DEVOLUCION_DE_PRODUCTO].includes(
                          document?.typeCode
                        )
                      " (refreshMonitor)="onDataRefreshed()">
                    </app-table-load-list-smart-grid>
                  </ng-container>
                </div>
              </div>
              <!-- Sección nueva-->
              <div class="mx-4" *ngIf="dataSourceExpenses.data.length > 0">
                <div
                  class="flex gap-6 items-center justify-between p-4 border mt-4 border-gray-200 rounded-lg shadow-sm cursor-pointer hover:bg-gray-100"
                  (click)="activeExpenses()">
                  <div class="flex items-center space-x-2">
                    <span class="font-semibold text-gray-900">GASTOS DE RUTA</span>
                    <div
                      class="cursor-pointer p-2 w-min h-6 rounded-full text-white flex items-center justify-center shadow-md transition text-xs"
                      [ngClass]="'bg-green-500'">
                      {{totalItemsExpense}}
                    </div>
                  </div>
                  <mat-icon [svgIcon]="
                      expenseListActive
                        ? 'heroicons_outline:chevron-up'
                        : 'heroicons_outline:chevron-down'
                    "></mat-icon>
                </div>

                <div *ngIf="expenseListActive" class="pt-4">
                  <ng-container *ngIf="totalItemsExpense > 0; else noExpenses">
                    <app-expense-load-list [tripId]="tripIdExpense"></app-expense-load-list>
                  </ng-container>

                  <!-- Template alternativo si no hay gastos -->
                  <ng-template #noExpenses>
                    <p class="text-gray-500 italic">No se registraron gastos en esta ruta.</p>
                  </ng-template>
                </div>
              </div>

            </mat-tab>
            <mat-tab label="Clientes">
              <ng-container *ngTemplateOutlet="documentbyClient"></ng-container>
            </mat-tab>
            <mat-tab label="Materiales">
              @if (workInProgressSubTabsIndex === 2) {
              <ng-container *ngTemplateOutlet="documentbyMaterial"></ng-container>
              }
            </mat-tab>
            <mat-tab label="Total Recaudado ({{ totalPaying | moneda }} {{totalUnit}})" (selectedTabChange)="onTabChange($event)">
              <app-payment-methods-tab [payments]="dataSourcePayments.data" [totalUnit]="totalUnit" [showActions]="true"
                (onOpenHistory)="openHistory($event)" (onOpenCreditNote)="openCreditNoteDetail($event)"
                (onToggleInner)="toggleInner($event)">
                <div slot="expanded-content">
                  <ng-container
                    *ngTemplateOutlet="nestedTableTemplateInner; context: { $implicit: row }"></ng-container>
                </div>
              </app-payment-methods-tab>
              <br>
              
              <ng-container *ngIf="showExpenseTab">
                <h1>Motivos de gastos</h1>
                <app-expense-totals-tab [expenses]="dataSourceExpenses" [totalUnit]="totalUnit" [tripId]="tripIdExpense"></app-expense-totals-tab>
              </ng-container>
              
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                <div class="flex flex-row items-center gap-2">
                  <span>Documento de Liquidación</span>
                </div>
              </ng-template>
              <app-liquidations [tripId]="selectedMR?.id" [UMPActive$]="UMPActive$"></app-liquidations>
            </mat-tab>
          </mat-tab-group>
        </mat-tab>
        <mat-tab >
          <ng-template mat-tab-label>
            <div class="flex flex-row items-center gap-2">
              <mat-icon svgIcon="heroicons_solid:truck" class="w-6 h-6" [matBadge]="statusRoute.countDocument"
                [matMenuTriggerFor]="actionMenuInfo" [ngClass]="
                  statusRoute.visitNotValid > 0 ? 'badge-amber' : 'badge-green'
                "></mat-icon>
              <mat-menu #actionMenuInfo="matMenu">
                <div class="w-53 p-3 flex flex-col gap-3">
                  <div class="flex flex-row">
                    <div
                      class="cursor-pointer w-6 h-6 p-2 mr-3 rounded-full bg-amber-500 text-white flex items-center justify-center shadow-md text-sm">
                      {{ statusRoute.visitNotValid || 0 }}
                    </div>
                    <span matBadgeColor="warn" matBadgeOverlap="false" class="inline-block">
                      Visita No Valida
                    </span>
                  </div>

                  <div class="flex flex-row">
                    <div
                      class="cursor-pointer w-6 h-6 p-2 mr-3 rounded-full bg-green-500 text-white flex items-center justify-center shadow-md text-sm">
                      {{ statusRoute.visitValid || 0 }}
                    </div>
                    <span matBadgeColor="warn" matBadgeOverlap="false" class="inline-block">
                      Visita Valida
                    </span>
                  </div>
                </div>
              </mat-menu>
              <span>Recorrido</span>
            </div>
          </ng-template>
          
           <div>
            <div *ngIf="isVisibleVisit" class="px-4 pt-4 bg-gray-100 rounded-lg shadow-md">
              <div class="grid grid-cols-4 gap-4">

                <div class="p-4 bg-white shadow-md rounded-lg text-center">
                  <div class="flex flex-row items-center justify-center">
                    <button mat-button color="primary" (click)="openDocumentsMapWindow(monitorDocumentTypeEnum.VISIT)"
                      matTooltip="Ver mapa">
                      <mat-icon [svgIcon]="'heroicons_outline:map-pin'"></mat-icon>
                    </button>
                  </div>
                </div>
              </div>

              <div class="flex justify-end mt-4">
                <button (click)="isVisibleVisit = !isVisibleVisit" class="px-8 bg-white shadow-md rounded-t-lg h-6">
                  <mat-icon svgIcon="heroicons_solid:chevron-up" class="text-xs"></mat-icon>
                </button>
              </div>
            </div>
            <ng-container *ngIf="!isVisibleVisit">
              <div class="flex justify-end">
                <button (click)="isVisibleVisit = !isVisibleVisit" class="px-8 bg-white shadow-md rounded-b-lg h-6">
                  <mat-icon svgIcon="heroicons_solid:chevron-down" class="text-xs"></mat-icon>
                </button>
              </div>
            </ng-container>
          </div>

          <ng-container *ngTemplateOutlet="
              rowDetailsTemplate;
              context: {
                dataSourceItemsRoutes,
              }
            "></ng-container>
          <ng-template #rowDetailsTemplate let-order>
     <div class="mb-20 w-full mx-auto block overflow-hidden" >
                         <app-smart-grid
                          [data]="dataSourceItemsRoutes"
                          [columnDefs]="visitsColumnDefs"
                          [config]="visitsGridConfig"
                          [loading]="loadingVisits"
                          (gridReady)="onGridReadyVisits($event)">
                        </app-smart-grid>
      </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
  </ng-template>

  <!-- Docuemntso por cliente  -->

  <ng-template #documentbyClient>
    <table mat-table [dataSource]="dataSourceItemsDocuments" class="min-w-500 overflow-y-visible mat-elevation-z"
      multiTemplateDataRows>
      <ng-container matColumnDef="expandable">
        <th mat-header-cell *matHeaderCellDef class="px-6 text-left first-col w-min-detail-b"></th>
        <td mat-cell *matCellDef="let element" class="px-6 first-col cursor-pointer group-hover:bg-gray-100">
          <button (click)="toggleDetailsDocument(element)" class="rounded-full p-1 px-6">
            <i class="fas" [ngClass]="{
                'fa-chevron-down': selectedDocument?.id !== element?.id,
                'fa-chevron-up': selectedDocument?.id === element?.id,
              }"></i>
          </button>
          <!-- </button> -->
        </td>
      </ng-container>

      <ng-container matColumnDef="circle">
        <th mat-header-cell *matHeaderCellDef class="text-center first-col w-min-detail"></th>
        <td mat-cell *matCellDef="let element" class="text-center first-col w-min-detail">
          <div class="circle"></div>
        </td>
      </ng-container>

      <ng-container matColumnDef="shipTo">
        <th mat-header-cell *matHeaderCellDef class="px-6 text-left table-tittle">
          Socio de Negocio
        </th>

        <td mat-cell *matCellDef="let element" class="px-6 text-left table-text text-uppercase">
          <!-- <div class="flex flex-row items-center">
                          <div class="circle"></div> -->
          <p class="uppercase">
            <span class="table-text-code">{{
              element?.shipTo?.externalKeys?.code
              }}</span><br />
            {{ element?.shipTo?.name }}
          </p>

          <!-- </div>   -->
        </td>
      </ng-container>

      <ng-container matColumnDef="document">
        <th mat-header-cell *matHeaderCellDef class="px-6 text-center table-tittle">
          Cnt. Documentos
        </th>
        <td mat-cell *matCellDef="let element" class="px-6 text-center table-text text-sm">
          {{ element?.orderCount }}
        </td>
      </ng-container>

      <ng-container matColumnDef="noSync">
        <th mat-header-cell *matHeaderCellDef class="px-6 text-center table-tittle">
          No se Sincronizan
        </th>
        <td mat-cell *matCellDef="let element" class="px-6 text-center table-text text-sm">
          {{ element?.statusCounts?.notSynchronized }}
        </td>
      </ng-container>
      <ng-container matColumnDef="toSync">
        <th mat-header-cell *matHeaderCellDef class="px-6 text-center table-tittle">
          Por Sincronizar
        </th>
        <td mat-cell *matCellDef="let element" class="px-6 text-center table-text text-sm">
          {{ element?.statusCounts?.toSynchronized }}
        </td>
      </ng-container>
      <ng-container matColumnDef="sync">
        <th mat-header-cell *matHeaderCellDef class="px-6 text-center table-tittle">
          <div class="flex items-center justify-center gap-2">
            <span>Sincronizados</span>
            <button mat-icon-button color="primary" (click)="exportCustomers()" matTooltip="Exportar">
              <mat-icon [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element" class="px-6 text-center table-text text-sm">
          {{ element?.statusCounts?.synchronized }}
        </td>
      </ng-container>
      <!-- <ng-container matColumnDef="price">
                        <th mat-header-cell *matHeaderCellDef class="px-6 text-center table-tittle">Precio({{this.currency}})</th>
                        <td mat-cell *matCellDef="let element" class="px-6 text-center table-text"> {{ element.subTotal | moneda}} </td>
                      </ng-container> -->

      <!-- <ng-container matColumnDef="loan">
                        <th mat-header-cell *matHeaderCellDef class="px-6 text-center table-tittle">Carga</th>
                        <td mat-cell *matCellDef="let element" class="px-6 text-center table-text">
                            {{element.loan | number : '1.3-3' }} {{element.weightUnitOfMeasureCode}}
                        </td>
                      </ng-container> -->

      <ng-container matColumnDef="expanded">
        <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
          <ng-container *ngIf="selectedDocument?.id === element?.id">
            <ng-container *ngTemplateOutlet="
                nestedTableTemplate;
                context: { $implicit: element }
              "></ng-container>
          </ng-container>
        </td>
      </ng-container>

      <!-- Cabeceras -->

      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky top-0  bg-white dark:bg-gray-900"></tr>
      <tr mat-row *matRowDef="let element; columns: displayedColumns"
        [class.table-expanded-row]="selectedDocument?.id === element?.id"></tr>

      <!-- Filas de detalles -->
      <tr mat-row *matRowDef="let row; columns: ['expanded']" class="table-detail-row"></tr>
    </table>
  </ng-template>
  <!--Sub tabla documetnos -->

  <ng-template #nestedTableTemplate>
    <div class="px-3 flex w-full flex-col ml-4">
      <table mat-table [dataSource]="dataSourceItemsSubDocuments"
        class="w-width min-w-500 overflow-y-visible mat-elevation-z" style="padding-top: 0px" multiTemplateDataRows>
        <ng-container matColumnDef="expandable">
          <th mat-header-cell *matHeaderCellDef class="px-6 text-left first-col w-min-detail-b"></th>
          <td mat-cell *matCellDef="let innerDetail" class="px-6 first-col cursor-pointer max-w-26">
            <button class="rounded-full p-1 py-6" (click)="toggleShip(innerDetail)">
              <i class="fas" [ngClass]="{
                  'fa-chevron-down':
                    selectedShip?.serial !== innerDetail?.serial,
                  'fa-chevron-up': selectedShip?.serial === innerDetail?.serial,
                }"></i>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef class="text-left first-col table-tittle w-min-p"></th>
          <td *matCellDef="let innerDetail" class="text-left first-col table-text">
            <mat-icon *ngIf="innerDetail.statusId == StatusEnum.INACTIVE" svgIcon="heroicons_solid:x-circle" matTooltip="Anulado"
              style="color: rgb(141, 19, 19); cursor: pointer"></mat-icon>
            <mat-icon *ngIf="innerDetail.statusId == StatusEnum.ACTIVE" svgIcon="heroicons_solid:check-circle" matTooltip="Activo"
              style="color: rgb(65, 106, 218); cursor: pointer"></mat-icon>
            <mat-icon *ngIf="innerDetail.statusId == StatusEnum.ORDER_IN_PROGRESS" svgIcon="heroicons_solid:play-circle" matTooltip="En progreso"
              style="color: rgb(236, 199, 58); cursor: pointer"></mat-icon>
            <mat-icon *ngIf="innerDetail.statusId == StatusEnum.ORDER_APPROVED" svgIcon="heroicons_solid:check-circle" matTooltip="Aprobado"
              style="color: rgb(9, 133, 50); cursor: pointer"></mat-icon>
            <mat-icon *ngIf="innerDetail.statusId == StatusEnum.ORDER_REJECTED" svgIcon="heroicons_solid:x-circle" matTooltip="Rechazado"
              style="color: rgb(255, 0, 0); cursor: pointer"></mat-icon>
            <!--<mat-icon *ngIf="element.statusId == StatusEnum.ORDER_DELIVERED" svgIcon="heroicons_solid:check-circle" matTooltip="Pedido Finalizado" style="color:rgb(9, 133, 50)"></mat-icon>-->
          </td>
        </ng-container>
        <ng-container matColumnDef="statusERP">
          <th mat-header-cell *matHeaderCellDef class="text-left first-col table-tittle w-min-p"></th>
          <td mat-cell *matCellDef="let innerDetail" class="text-left first-col table-text">
            <mat-icon *ngIf="innerDetail.statusERP == OrderStatusERPEnum.ORDER_PENDING || !innerDetail.statusERP" svgIcon="heroicons_solid:clock"
              matTooltip="Pendiente envío a ERP" style="color: rgb(233, 124, 61); cursor: pointer"></mat-icon>
            <mat-icon *ngIf="innerDetail.statusERP == OrderStatusERPEnum.ORDER_SEND" svgIcon="heroicons_solid:document-arrow-up"
              matTooltip="Enviado a ERP" style="color: rgb(65, 106, 218); cursor: pointer"></mat-icon>
            <mat-icon *ngIf="innerDetail.statusERP == OrderStatusERPEnum.ORDER_RECEIVED" svgIcon="heroicons_solid:document-arrow-down"
              matTooltip="Recibido por ERP" style="color: rgb(236, 199, 58); cursor: pointer"></mat-icon>
            <mat-icon *ngIf="innerDetail.statusERP == OrderStatusERPEnum.ORDER_CREATED" svgIcon="heroicons_solid:document-check"
              matTooltip="Creado en ERP" style="color: rgb(9, 133, 50); cursor: pointer"></mat-icon>
            <mat-icon *ngIf="innerDetail.statusERP == OrderStatusERPEnum.ORDER_ERROR" svgIcon="heroicons_solid:exclamation-triangle"
              matTooltip="Error enviando a ERP" style="color: rgb(141, 19, 19); cursor: pointer"></mat-icon>
            <mat-icon *ngIf="innerDetail.statusERP == OrderStatusERPEnum.ORDER_PENDING_FOR_UPDATE" svgIcon="heroicons_solid:clock"
              matTooltip="Mod. pendiente de replicar" style="color: rgb(148, 46, 139); cursor: pointer"></mat-icon>
            <mat-icon *ngIf="innerDetail.statusERP == OrderStatusERPEnum.ORDER_ERROR_ERP" svgIcon="heroicons_solid:exclamation-triangle"
              matTooltip="Error en ERP" style="color: rgb(255, 0, 0); cursor: pointer"></mat-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef class="px-6 text-left first-col table-tittle">
            Tipo Documento
          </th>
          <td mat-cell *matCellDef="let innerDetail" class="px-6 text-left first-col table-text">
            <p class="table-text-m text-uppercase text-sm">
              <span class="table-text-code">{{ innerDetail?.type?.code }}</span><br />
              {{ innerDetail?.type?.name }}
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="class">
          <th mat-header-cell *matHeaderCellDef class="px-6 text-left first-col table-tittle">
            Clase Documento
          </th>
          <td mat-cell *matCellDef="let innerDetail" class="px-6 text-left first-col table-text">
            <p class="table-text-m text-uppercase">
              <span class="table-text-code">{{ innerDetail?.class?.code }}</span><br />
              {{ innerDetail?.class?.name }}
            </p>
          </td>
        </ng-container>

        <ng-container matColumnDef="loan">
          <th mat-header-cell *matHeaderCellDef class="px-6 text-right first-col table-tittle">
            Peso
          </th>
          <td mat-cell *matCellDef="let innerDetail" class="px-6 text-right first-col table-text">
            {{ innerDetail.loan | number: "1.3-3" }}
            {{ innerDetail.weightUnitOfMeasureCode }}
          </td>
        </ng-container>

        <ng-container matColumnDef="price">
          <th mat-header-cell *matHeaderCellDef class="text-right">
            <p class="px-6">Total</p>
          </th>
          <td mat-cell *matCellDef="let innerDetail" class="text-right text-uppercase">
            <p class="px-6">{{ innerDetail?.total | decimalFormat }}</p>
          </td>
        </ng-container>

        <ng-container matColumnDef="serial">
          <th mat-header-cell *matHeaderCellDef class="px-6 text-left first-col table-tittle">
            Nro. Documento
          </th>
          <td mat-cell *matCellDef="let innerDetail" class="px-6 text-left first-col table-text">
            <app-document-navigation [documentType]="innerDetail?.type?.code || ''"
              [documentSerial]="innerDetail?.serial" [displayText]="innerDetail?.serial || '-'"
              [showIcon]="!!innerDetail?.serial">
            </app-document-navigation>
          </td>
        </ng-container>

        <ng-container matColumnDef="expanded">
          <td mat-cell *matCellDef="let innerDetail" [attr.colspan]="displayedColumnsShip.length">
            <ng-container *ngIf="selectedShip?.serial === innerDetail?.serial" class="details-row">
              <ng-container *ngTemplateOutlet="
                  material;
                  context: { $implicit: innerDetail }
                "></ng-container>
            </ng-container>
          </td>
        </ng-container>

        <!-- Cabeceras -->

        <tr mat-header-row *matHeaderRowDef="displayedColumnsShip" class="sticky top-0  bg-white dark:bg-gray-900">
        </tr>
        <tr mat-row *matRowDef="let innerDetail; columns: displayedColumnsShip" [class.table-expanded-row]="
            selectedShip?.serial === innerDetail?.serial
          "></tr>

        <!-- Filas de detalles -->
        <tr mat-row *matRowDef="let row; columns: ['expanded']" class="table-detail-row"></tr>

        <!-- <tr mat-header-row *matHeaderRowDef="displayedColumnsShip" class="sticky top-0  bg-white dark:bg-gray-900"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsShip;" class="table-detail-row"></tr> -->
      </table>
    </div>
  </ng-template>

  <ng-template #material>
    <div class="py-3 flex w-full flex-col ml-4">
      <table mat-table [dataSource]="dataSourceMaterialDocuments" class="min-w-500 overflow-y-visible mat-elevation-z"
        multiTemplateDataRows>
        <ng-container matColumnDef="material">
          <th mat-header-cell *matHeaderCellDef class="text-left first-col table-tittle">
            <p class="px-6">Material</p>
          </th>
          <td mat-cell *matCellDef="let innerDetail" class="text-left first-col table-text">
            <p class="px-6 py-2 table-text-m text-uppercase">
              <span class="table-text-code">{{
                innerDetail?.material?.externalKeys?.code
                }}</span><br />
              {{ innerDetail?.material?.name }}
            </p>
          </td>
        </ng-container>

        <ng-container matColumnDef="quantity">
          <th mat-header-cell *matHeaderCellDef class="px-6 text-right first-col table-tittle">
            Cantidad
          </th>
          <td mat-cell *matCellDef="let innerDetail" class="px-6 text-right first-col table-text">
            {{ innerDetail.baseQuantity | number: "1.3-3" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="loan">
          <th mat-header-cell *matHeaderCellDef class="px-6 text-right first-col table-tittle">
            Cnt. Carga
          </th>
          <td mat-cell *matCellDef="let innerDetail" class="px-6 text-right first-col table-text">
            {{ innerDetail?.baseQuantity | number: "1.3-3" }}
            {{ innerDetail?.baseUnitOfMeasure?.code }}
          </td>
        </ng-container>

        <ng-container matColumnDef="price">
          <th mat-header-cell *matHeaderCellDef class="text-right">
            <p class="px-6">Precio</p>
          </th>
          <td mat-cell *matCellDef="let innerDetail" class="px-6 text-right text-uppercase">
            <p class="px-6">{{ innerDetail?.originalUnitPrice | moneda }}</p>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsMaterial"
          class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsMaterial" class="table-detail-row"></tr>
      </table>
    </div>
  </ng-template>
  <!-- Datos Tabla Principal Carga Vista Todo-->

  <ng-template #tableMainCharge let-charge="charge" let-exportFn="exportFn">
    <table class="min-w-500" mat-table [dataSource]="charge" matSort #sortMainCharge="matSort" matSortDisableClear
      multiTemplateDataRows>
      <ng-container matColumnDef="det">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row" style="width: 5px">
          <button class="h-7 min-h-7 min-w-10 px-2 leading-6" mat-icon-button (click)="toggleDetailsCharge(row)"
            style="margin-left: 10px">
            <mat-icon class="icon-size-5" [svgIcon]="
                selectedCharge?.shipTo._id === row.shipTo._id
                  ? 'heroicons_solid:chevron-up'
                  : 'heroicons_solid:chevron-down'
              "></mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- Socio de Negocio -->
      <ng-container matColumnDef="businesspartner">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left first-col whitespace-nowrap">
          Socio de Negocio
        </th>
        <td mat-cell *matCellDef="let data" class="text-left text-sm text-uppercase whitespace-nowrap">
          <p>
            <span class="table-text-code">{{
              data?.shipTo?.externalKeys?.code
              }}</span><br />
            {{ data?.shipTo?.name }}
          </p>
        </td>
      </ng-container>

      <!--  Nro. Documento -->
      <ng-container matColumnDef="noDocument">
        <th mat-header-cell *matHeaderCellDef mat-sort-header
          class="text-left first-col table-tittle whitespace-nowrap">
          Nro. Documentos
        </th>
        <td mat-cell *matCellDef="let data" class="text-left text-sm first-col">
          {{ data?.orderCount }}
        </td>
      </ng-container>

      <!-- Total(LE) -->
      <ng-container matColumnDef="total">
        <th mat-header-cell mat-sort-header *matHeaderCellDef class="px-6 text-right">
          Total (<label>{{ totalUnit }}</label>)
        </th>
        <td mat-cell *matCellDef="let data" class="text-right text-sm whitespace-nowrap">
          {{ data?.total | decimalFormat }}
        </td>
      </ng-container>

      <!-- Acciones -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left">
        <div class="w-full flex items-center justify-center">
            <button class="mr-4" mat-button color="primary" (click)="exportFn()" matTooltip="Exportar">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
          </button>
        </div>
        </th>
        <td mat-cell *matCellDef="let row" class="px-6 py-3 text-left">
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let row" [attr.colspan]="displayColumsChargeGeneral.length">
          <ng-container *ngIf="selectedCharge?.shipTo._id === row.shipTo._id">
            <ng-container *ngTemplateOutlet="tableMainChargeItems; context: { charge: row }"></ng-container>
          </ng-container>
        </td>
      </ng-container>

      <!-- Header Row -->
      <tr mat-header-row *matHeaderRowDef="displayColumsChargeGeneral"
        class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>

      <!-- Fila Principal -->
      <tr mat-row *matRowDef="let row; columns: displayColumsChargeGeneral" class="border-b" [class.table-expanded-row]="
          selectedCharge?.shipTo._id === row.shipTo._id
        "></tr>

      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="table-detail-row"></tr>
    </table>
    <!-- MatPaginator -->
    <mat-paginator class="z-10" [pageSizeOptions]="[5, 10, 50, 100, 150]" showFirstLastButtons [length]="
        activeTable === 'delivery' ? deliveryTotalItems : chargeTotalItems
      " [pageSize]="pageSizeLoan" (page)="changePage($event)"></mat-paginator>
  </ng-template>

  <ng-template #tableMainChargeItems>
    <div class="w-full bg-white ml-4 mt-2">
      <app-smart-grid
        [data]="dataSourceItemsSubCharge.data"
        [columnDefs]="chargeOrdersColumnDefs"
        [config]="chargeOrdersGridConfig"
        [detailTemplate]="rowExpansionTemplate">

        <!-- Row Expansion Template for Material Details -->
        <ng-template #rowExpansionTemplate let-row>
          <div class="p-4 bg-white dark:bg-gray-900">
            <div class="ml-2">
              <app-smart-grid
                [data]="row?.detail || []"
                [columnDefs]="materialDetailsColumnDefs"
                [config]="materialDetailsGridConfig">
              </app-smart-grid>

              <!-- Empty State for Material Details -->
              <div *ngIf="!row?.detail || row?.detail?.length === 0"
                   class="border-t p-8 text-center text-sm">
                No hay materiales para mostrar.
              </div>
            </div>
          </div>
        </ng-template>
      </app-smart-grid>

      <!-- Empty State for Orders -->
      <div *ngIf="!dataSourceItemsSubCharge.data || dataSourceItemsSubCharge.data.length === 0"
           class="border-t p-8 text-center text-1xl sm:p-10">
        Lo sentimos, no hay registros para mostrar.
      </div>
    </div>
  </ng-template>

  <!-- Subdados de document  -->
  <ng-template #rowDetailsSubDocumentTemplate>
    <div class="flex-1 flex flex-col h-full overflow-hidden ml-4">
      <div class="flex-1 flex flex-col overflow-hidden my-6">
        <!-- Header -->
        <div class="overflow-y-auto max-h-96 sticky top-0 z-10 bg-gray-100 dark:bg-gray-900">
          <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table
            [dataSource]="dataSourceItemsSubDocuments" matSort #sortSubDocument="matSort" matSortDisableClear
            multiTemplateDataRows>
            <!-- Material -->
            <ng-container matColumnDef="material">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left whitespace-nowrap">
                <p class="px-6">Material</p>
              </th>
              <td mat-cell *matCellDef="let data" class="text-left text-uppercase flex flex-row mt-4 whitespace-nowrap">
                <p class="px-6">
                  <span class="table-text-code">{{ data?.material?.code }}</span><br />
                  {{ data?.material?.name }}
                </p>
              </td>
            </ng-container>

            <!--  Precio -->
            <ng-container matColumnDef="price">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle">
                Precio
              </th>
              <td mat-cell *matCellDef="let data" class="text-left first-col table-text">
                <p class="table-text-m text-left">
                  {{ data?.subTotal | decimalFormat }}
                </p>
              </td>
            </ng-container>

            <!-- Carga -->
            <ng-container matColumnDef="cntLoad">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-le whitespace-nowrap">
                Carga
              </th>
              <td mat-cell *matCellDef="let data" class="px-6 text-left whitespace-nowrap">
                {{ data?.baseQuantity | number: "1.3-3" }}
                {{ data.baseUnitOfMeasure.code }}
              </td>
            </ng-container>

            <!-- Numero de Solicitud -->
            <ng-container matColumnDef="reference">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-le whitespace-nowrap">
                Referencia
              </th>
              <td mat-cell *matCellDef="let data" class="px-6 text-left whitespace-nowrap uppercase">
                {{ data.reference ?? " - " }}
              </td>
            </ng-container>

            <!-- Numero de Solicitud -->
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-le whitespace-nowrap">
                Tipo
              </th>
              <td mat-cell *matCellDef="let data" class="px-6 text-left whitespace-nowrap uppercase">
                {{ data.typeName ?? " - " }}
              </td>
            </ng-container>

            <!-- Numero de Solicitud -->
            <ng-container matColumnDef="noDelivery">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-le whitespace-nowrap">
                Nro. Entrega
              </th>
              <td mat-cell *matCellDef="let data" class="px-6 text-left whitespace-nowrap uppercase">
                <app-document-navigation [documentType]="DocumentTypeEnum.ENTREGA_ENTRADA" [documentSerial]="data?.serial"
                  [displayText]="data?.serial || '-'" [showIcon]="!!data?.serial">
                </app-document-navigation>
              </td>
            </ng-container>

            <!-- Numero de Solicitud -->
            <ng-container matColumnDef="noBilling">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-sm whitespace-nowrap">
                Nro. Factura
              </th>
              <td mat-cell *matCellDef="let data" class="px-6 text-left whitespace-nowrap uppercase">
                <app-document-navigation [documentType]="DocumentTypeEnum.FACTURA" [documentSerial]="data?.noBilling"
                  [displayText]="data?.noBilling || '-'" [showIcon]="!!data?.noBilling">
                </app-document-navigation>
              </td>
            </ng-container>

            <!-- Header Row -->
            <tr mat-header-row *matHeaderRowDef="displayColumsSubDocument"
              class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>

            <!-- Fila Principal -->
            <tr mat-row *matRowDef="let row; columns: displayColumsSubDocument" class="border-b"
              [class.table-expanded-row]="selectedDocument?.code === row.code"></tr>
          </table>
        </div>
        <div *ngIf="this.dataSourceItemsSubDocuments.data.length === 0"
          class="border-t p-8 text-center text-1xl sm:p-10">
          Lo sentimos, no hay registros para mostrar.
        </div>
      </div>
    </div>
  </ng-template>
</section>

<ng-template #viewRoutesByVehicleIdModal>
  <app-routes-detail-by-business-partner-vehicle [typeModal]="'vehicle'" [parameterId]="parameterIdForVehicles"
    [search]="false">
  </app-routes-detail-by-business-partner-vehicle>
</ng-template>

<!-- Modal editar -->
<ng-template #editModal let-data>
  <div class="flex items-center justify-between mb-2">
    <h2 mat-dialog-title class="text-lg font-bold m-0">Editar Registro</h2>
    <button *ngIf="parameterIdForVehicles.length > 0" mat-flat-button color="primary"
      (click)="openRoutesByVehicleIdModal()">
      <mat-icon class="icon-size-5">link</mat-icon>
      <span class="ml-2">Rutas y viajes asociados</span>
    </button>
  </div>
  <mat-dialog-content class="modal-content-update">
    <div class="grid grid-cols-1 gap-4 col-span-2 mt-2">
      <div class="col-span-1">
        <label for="group-select">Usuario</label>
        <ng-select [(ngModel)]="currentUpdateTrip.masterUserId" [items]="userMasterList" bindLabel="username"
          bindValue="_id" [searchable]="true" placeholder="Seleccione el usuario" name="masterUserId"
          [appendTo]="'body'">
          <ng-template ng-label-tmp let-item="item">
            <span>
              {{ item.user_login_username }}
              <ng-container *ngIf="item.businessPartnerName">
                - {{ item.businessPartnerName }}</ng-container>
            </span>
            <!-- Mostramos el código y el nombre -->
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
            <span>
              {{ item.user_login_username }}
              <ng-container *ngIf="item.businessPartnerName">
                - {{ item.businessPartnerName }}</ng-container>
            </span>
            <!-- Mostramos el código y el nombre -->
          </ng-template>
        </ng-select>
      </div>
      <div class="col-span-1">
        <label>Vehículo</label>
        <ng-select [(ngModel)]="currentUpdateTrip.vehicleId" [items]="vechicleListGeneral" bindLabel="name"
          bindValue="_id" [searchable]="true" placeholder="Seleccione un vehículo" name="vehicleId" [appendTo]="'body'"
          (ngModelChange)="onVehicleSelected($event)">
          <ng-template ng-label-tmp let-item="item">
            <span class="text-sm"><b>{{ item?.externalKeys?.code }}</b> - {{ item?.name }}</span>
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
            <span class="text-sm"><b>{{ item?.externalKeys?.code }}</b> - {{ item?.name }}</span>
          </ng-template>
        </ng-select>
      </div>
      <div class="col-span-1">
        <div class="col-span-1">
          <label>Estado de Viaje</label>
          <ng-select [(ngModel)]="currentUpdateTrip.statusTripId" [items]="statusList" bindLabel="value"
            bindValue="code" [searchable]="true" placeholder="Seleccione una Estado" name="statusId"
            [appendTo]="'body'">
            <ng-template ng-label-tmp let-item="item">
              <span class="text-sm text-uppercase"> {{ item?.value }}</span>
            </ng-template>

            <ng-template ng-option-tmp let-item="item">
              <span class="text-sm text-uppercase">{{ item?.value }}</span>
            </ng-template>
          </ng-select>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="modal-actions flex justify-between">
    <button mat-button mat-dialog-close class="align-left">Cancelar</button>
    <button [disabled]="!isValidateFormUpdate" mat-raised-button color="primary" [mat-dialog-close]="true">
      Guardar
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #editAdvert let-data>
  <div class="flex items-start space-x-2 m-4">
    <div class="flex items-center">
      <mat-icon class="text-amber-500 ml-4 mt-6" style="font-size: 32px">warning_amber</mat-icon>
    </div>
    <div class="grid">
      <h2 mat-dialog-title class="text-lg font-bold mb-1">
        {{ data.title }}
      </h2>
      <mat-dialog-content class="modal-content mt-0">
        <p>{{ data.description }}</p>
      </mat-dialog-content>
    </div>
  </div>
  <mat-dialog-actions class="modal-actions flex justify-between">
    <button mat-raised-button color="primary" [mat-dialog-close]="true">
      Ok
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #viewDownloadResumeModal>
  <app-download-resume-routes-monitor [tripId]="tripIdDownload"></app-download-resume-routes-monitor>
</ng-template>

<ng-template #editModalDistribution let-data>
  <h2 mat-dialog-title class="text-lg font-bold mb-1">Editar Distribución</h2>
  <mat-dialog-content class="modal-content-update">
    <div class="flex-1 flex flex-col h-full overflow-hidden ml-4">
      <div class="flex-1 flex flex-col overflow-hidden my-6">
        <!-- Header -->
        <div class="overflow-y-auto max-h-96 sticky top-0 z-10 bg-gray-100 dark:bg-gray-900">
          <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table [dataSource]="deliveryGroupUnified"
            matSort #sortSubDocument="matSort" matSortDisableClear multiTemplateDataRows>
            <ng-container matColumnDef="det">
              <th mat-header-cell *matHeaderCellDef class="w-15"></th>
              <td *matCellDef="let row" class="w-15">
                <button class="h-7 min-h-7 leading-6 px-2" (click)="toggleGroupUnified(row)">
                  <mat-icon class="icon-size-5" [svgIcon]="
                      selectGroupUnified?.noDto.serial === row?.noDto.serial
                        ? 'heroicons_solid:chevron-up'
                        : 'heroicons_solid:chevron-down'
                    "></mat-icon>
                </button>
              </td>
            </ng-container>

            <!--  Nro. Doc. -->
            <ng-container matColumnDef="noDtn">
              <th mat-header-cell *matHeaderCellDef class="first-col table-tittle text-left">
                <p class="px-6">Nro. Doc.</p>
              </th>
              <td mat-cell *matCellDef="let data" class="first-col table-text text-left">
                <div class="flex flex-row gap-4 items-center">
                  <mat-icon class="text-amber-500 text-md" [ngClass]="{
                      invisible: data.totalSpare <= 0,
                    }" svgIcon="heroicons_outline:exclamation-triangle"
                    matTooltip="Existe carga por asignar"></mat-icon>
                  <div>
                    <p class="table-text-m text-righ font-semibold">
                      {{ data?.noDto.serial ?? " - " }}
                    </p>
                    <p class="table-text-m text-righ">
                      {{ data?.noDto.code ?? " - " }}
                    </p>
                  </div>
                </div>
              </td>
            </ng-container>

            <!--  Alerta  -->
            <ng-container matColumnDef="warning">
              <th mat-header-cell *matHeaderCellDef class="first-col table-tittle text-right"></th>
              <td mat-cell *matCellDef="let data" class="first-col table-text text-right"></td>
            </ng-container>

            <ng-container matColumnDef="expanded">
              <td mat-cell *matCellDef="let row" [attr.colspan]="displayGruopUnified.length">
                <ng-container *ngIf="selectGroupUnified?.noDto.serial === row.noDto.serial">
                  <ng-container *ngTemplateOutlet="tableDistribution"></ng-container>
                </ng-container>
              </td>
            </ng-container>

            <!-- Header Row -->
            <tr mat-header-row *matHeaderRowDef="displayGruopUnified"
              class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>

            <!-- Fila Principal -->
            <tr mat-row *matRowDef="let row; columns: displayGruopUnified" [class.table-expanded-row]="
                selectGroupUnified?.noDto.serial === row?.noDto.serial
              "></tr>

            <!-- Filas de detalles -->
            <tr class="table-detail-row" mat-row *matRowDef="let row; columns: ['expanded']"></tr>
          </table>
        </div>

        <div *ngIf="this.deliveryGroupUnified.data.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">
          Lo sentimos, no hay registros para mostrar.
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="modal-actions flex justify-between">
    <button mat-button mat-dialog-close class="align-left">Cancelar</button>
    <span [matTooltip]="!isSaveDistribution ? 'Falta distribución por asignar' : ''">
      <button mat-raised-button color="primary" [disabled]="!isSaveDistribution" [mat-dialog-close]="true">
        Guardar
      </button>
    </span>
  </mat-dialog-actions>
</ng-template>

<ng-template #tableDistribution>
  <div class="flex-1 flex flex-col h-full overflow-hidden ml-4">
    <div class="flex-1 flex flex-col overflow-hidden my-6">
      <!-- Header -->
      <div class="overflow-y-auto max-h-96 sticky top-0 z-10 bg-gray-100 dark:bg-gray-900">
        <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table
          [dataSource]="deliveryGroupMaterialUnified" matSort (matSortChange)="onSortChange($event)"
          #sortSubDocument="matSort" matSortDisableClear multiTemplateDataRows>
          <ng-container matColumnDef="det">
            <th mat-header-cell *matHeaderCellDef>
              @if(showButtonSpare){
              <button color="primary" mat-button (click)="openSoldToEmptyDocument()" matTooltip="Agregar">
                <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
              </button>
              }
            </th>
            <td *matCellDef="let row">
              <button class="h-7 min-h-7 leading-6 px-2" (click)="toggleDistribution(row)">
                <mat-icon class="icon-size-5" [svgIcon]="
                    selectItemDistribution?.material._id +
                      selectItemDistribution?.serial ===
                    row?.material._id + row?.serial
                      ? 'heroicons_solid:chevron-up'
                      : 'heroicons_solid:chevron-down'
                  "></mat-icon>
              </button>
            </td>
          </ng-container>

          <!-- Material -->
          <ng-container matColumnDef="material">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left whitespace-nowrap">
              <p class="px-6">Material</p>
            </th>
            <td mat-cell *matCellDef="let data" class="text-left text-uppercase flex flex-row mt-4 whitespace-nowrap">
              <p class="px-6 text-sm">
                <span class="table-text-code">{{ data?.material?.code }}</span><br />
                {{ data?.material?.name }}
              </p>
            </td>
          </ng-container>

          <!--  Total UMB -->
          <ng-container matColumnDef="noDtn">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="first-col table-tittle text-right">
              Nro. Doc.
            </th>
            <td mat-cell *matCellDef="let data" class="first-col table-text text-right">
              <p class="table-text-m text-righ px-6">
                {{ data?.serial ?? " - " }}
              </p>
            </td>
          </ng-container>

          <!--  Faltante -->
          <ng-container matColumnDef="missing">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="first-col table-tittle text-right"
              [ngClass]="data?.missing > 0 ? 'text-red-500' : 'text-black'">
              Faltante
            </th>
            <td mat-cell *matCellDef="let data" class="first-col table-text text-right">
              <p class="table-text-m text-righ px-6">
                {{ data?.missing ?? 0 | number: "1.3-3" }}
              </p>
            </td>
          </ng-container>

          <!--  Faltante -->
          <ng-container matColumnDef="spare">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="first-col table-tittle text-right">
              Sobrante
            </th>
            <td mat-cell *matCellDef="let data" class="first-col table-text text-right"
              [ngClass]="data?.spare > 0 ? 'text-red-500' : 'text-black'">
              <p class="table-text-m text-righ px-6">
                {{ data?.spare ?? 0 | number: "1.3-3" }}
              </p>
            </td>
          </ng-container>

          <!--  Total UMB -->
          <ng-container matColumnDef="totalUMB">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="first-col table-tittle text-right">
              Total UMB
            </th>
            <td mat-cell *matCellDef="let data" class="first-col table-text text-right">
              <p class="table-text-m text-righ px-6">
                {{ data?.totalBaseQuantity | number: "1.3-3" }}
              </p>
            </td>
          </ng-container>

          <!--  Total UMP -->
          <ng-container matColumnDef="totalUMP">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="first-col table-tittle text-right">
              Total UMP
            </th>
            <td mat-cell *matCellDef="let data" class="first-col table-text text-right">
              <p class="table-text-m text-righ px-6">
                {{ data?.totalPararellQuantity | number: "1.3-3" }}
              </p>
            </td>
          </ng-container>

          <ng-container matColumnDef="expanded">
            <td mat-cell *matCellDef="let row" [attr.colspan]="displayColumsDistributionMain.length">
              <ng-container *ngIf="
                  selectItemDistribution?.material._id +
                    selectItemDistribution?.serial ===
                  row?.material._id + row.serial
                ">
                <ng-container *ngTemplateOutlet="
                    tablaItemDistribution;
                    context: { $implicit: row }
                  "></ng-container>
              </ng-container>
            </td>
          </ng-container>

          <!-- Header Row -->
          <tr mat-header-row *matHeaderRowDef="displayColumsDistributionMain"
            class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>

          <!-- Fila Principal -->
          <tr mat-row *matRowDef="let row; columns: displayColumsDistributionMain" [class.table-expanded-row]="
              selectItemDistribution?.material._id +
                selectItemDistribution?.serial ===
              row?.material._id + row?.serial
            "></tr>

          <!-- Filas de detalles -->
          <tr class="table-detail-row" mat-row *matRowDef="let row; columns: ['expanded']"></tr>
        </table>
      </div>
      <!--
        <div class="sticky bottom-0 z-50 bg-white dark:bg-gray-900 border-t">
        <mat-paginator
          #paginarionMaterial
          [pageSizeOptions]="[10, 50, 100, 150]"
          showFirstLastButtons
          [length]="totalItemsMaterial"
          [pageSize]="pageSizeMaterial"
          (page)="onPageChangeMaterial($event)"
        ></mat-paginator>
      </div>
      
      -->

      <div *ngIf="this.deliveryGroupMaterialUnified.data.length === 0"
        class="border-t p-8 text-center text-1xl sm:p-10">
        Lo sentimos, no hay registros para mostrar.
      </div>
    </div>
  </div>
</ng-template>

<ng-template #tablaItemDistribution>
  <div class="flex w-full flex-col">
    <table class="min-w-500 overflow-y-visible mat-elevation-z mt-3 ml-3" mat-table
      [dataSource]="dataSourceDistributionItemDetail" matSort>
      <ng-container matColumnDef="isNew">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left first-col table-tittle">
          <span class="pl-3"></span>
        </th>
        <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
          @if(detail.isNew){
          <mat-icon class="text-green-700 text-md" svgIcon="heroicons_outline:check-badge"></mat-icon>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="noDto">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left first-col table-tittle">
          <span class="pl-3">Nro. Doc.</span>
        </th>
        <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
          <p (click)="onHandleDetailOrder(detail.sourceTransaction.serial)"
            class="pl-3 font-semibold text-xs underline mb-2 cursor-pointer" matTooltip="Ver detalles">
            {{ detail.sourceTransaction.serial }}
          </p>
          <p class="pl-3 font-semibold text-xs">
            {{ detail.serial }}
          </p>
        </td>
      </ng-container>
      <ng-container matColumnDef="client">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left first-col table-tittle">
          <span style="margin-left: 5px">Cliente</span>
        </th>
        <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
          <p class="table-text-m">
            <span class="table-text-code">
              {{ detail.shipTo?.externalKeys.code }}
            </span>

            <br />
            <span>
              {{ detail.shipTo?.name }}
            </span>
          </p>
        </td>
      </ng-container>
      <ng-container matColumnDef="note">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left first-col table-tittle">
          Nota
        </th>
        <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
          <button mat-icon-button color="primary" matTooltip="{{ detail.note }}"
            [disabled]="!(detail.note && detail.note != '')">
            <mat-icon svgIcon="heroicons_outline:chat-bubble-bottom-center-text"></mat-icon>
          </button>
        </td>
      </ng-container>
      <ng-container matColumnDef="warehouse">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left first-col table-tittle">
          Almacén
        </th>
        <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
          <p *ngIf="!detail.isEditMode" class="table-text-m">
            <span class="table-text-code" *ngIf="getCode(detail.warehouse) as code">
              {{ code }} <br />
            </span>
            {{ detail.warehouse?.name }}
          </p>
          <mat-form-field *ngIf="detail.isEditMode" class="mt-2 w-full" appearance="fill" floatLabel="never">
            <mat-select [(ngModel)]="detail.warehouse" placeholder="Almacén" matTooltip="{{ detail.warehouse?.name }}"
              [ngModelOptions]="{ standalone: true }" [compareWith]="compareById" (selectionChange)="
                detail.thereIsChanges = true;
                onChangeWarehouseInOrderDetail(detail)
              ">
              @for (
              warehouse of selectedOrder.warehousesToUpdate || [];
              track warehouse
              ) {
              <mat-option [value]="warehouse" class="text-content">
                {{ warehouse.externalKeys?.code + " - " }}{{ warehouse.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>
      <ng-container matColumnDef="soldQuantity">
        <th mat-header-cell *matHeaderCellDef class="text-left first-col table-tittle">
          <span class="table-text-m-2 pd-l">Cantidad</span>
        </th>

        <td mat-cell *matCellDef="let detail" class="text-left first-col table-text">
          <div class="flex items-start justify-between">
            <div class="flex flex-row">
              <p *ngIf="!detail?.edit" class="table-text-m-2 pd-l">
                {{ detail?.soldQuantity | number: "1.3" }} ({{
                detail?.soldUnitOfMeasure?.name
                }}) <br />
                <app-unit-measure-display
                  [baseUnit]="{
                    quantity: detail?.baseQuantity,
                    unitId: detail?.baseUnitOfMeasure?._id,
                    unitName: detail?.baseUnitOfMeasure?.name,
                    unitAbbreviation: detail?.baseUnitOfMeasure?.code
                  }"
                  [parallelUnit]="{
                    quantity: detail?.pararellQuantity,
                    unitId: detail?.pararellUnitOfMeasure?._id,
                    unitName: detail?.pararellUnitOfMeasure?.name,
                    unitAbbreviation: detail?.pararellUnitOfMeasure?.code
                  }"
                  [material]="{
                    _id: detail?.material?._id,
                    code: detail?.material?.code,
                    UMPActive: detail?.material?.UMPActive
                  }"
                  [companyUMPActive]="UMPActive"
                  [statusId]="detail.statusId"
                ></app-unit-measure-display>
              </p>
              <mat-icon *ngIf="!detail?.edit" svgIcon="heroicons_outline:pencil-square" color="primary"
                class="self-center" (click)="onHandleEditUMBDetail(detail)" matTooltip="Editar unidad de medida base">
              </mat-icon>
              <div class="flex flex-row justify-center gap-2 self-center" *ngIf="detail?.edit">
                <mat-form-field appearance="fill" class="min-w-[12rem] pt-3" floatLabel="never">
                  <mat-select [(ngModel)]="detail.selectedUnit">
                    <mat-option [ngValue]="null" disabled selected>Selecciona una unidad</mat-option>
                    <mat-option value="UMB">UMB ({{detail?.baseUnitOfMeasure?.name}})</mat-option>
                    @if(UMPActive){
                    <mat-option value="UMP">UMP ({{detail?.pararellUnitOfMeasure?.name}})</mat-option>
                    }
                  </mat-select>
                </mat-form-field>

                @if(detail.selectedUnit){
                <mat-form-field appearance="fill" class="min-w-[16rem] pt-3">
                  <input matInput type="text" step="0.001" min="0" name="baseQuantity" placeholder="Cantidad"
                    class="text-sm"
                    [ngModel]="detail.selectedUnit == UnitOfMeasureEnum.UMB ? detail.baseQuantity : detail.pararellQuantity"
                    (ngModelChange)="validateInput($event, detail)" />
                </mat-form-field>
                }
                <mat-icon class="self-center" color="primary" matTooltip="Guardar unidad de medida base"
                  svgIcon="heroicons_outline:check" (click)="inputSaveUMB(detail)">
                </mat-icon>
                <mat-icon class="self-center text-red-500" matTooltip="Cancelar editar unidad de medida base"
                  svgIcon="heroicons_outline:x-mark" (click)="inputCancelUMB(detail)">
                </mat-icon>
              </div>
            </div>
            <button *ngIf="batchesDetail && detail?.batches.length > 0" mat-icon-button color="primary"
              (click)="openBatchesDetail(selectedOrder, detail)" matTooltip="Ver lotes">
              <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="science"></mat-icon>
            </button>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="unitPrice">
        <th mat-header-cell *matHeaderCellDef class="px-6 first-col table-tittle text-center">
          Precio
        </th>
        <td mat-cell *matCellDef="let detail" class="px-6 first-col table-text text-center">
          @if (
          detail.isEditMode && selectedOrder.class.canUpdatePrices == true
          ) {
          <mat-form-field class="mt-2" appearance="fill" floatLabel="never">
            <input matInput type="number" [(ngModel)]="detail.unitPrice" placeholder="Precio"
              [ngModelOptions]="{ standalone: true }" aria-label="Precio" matInput
              (change)="onChangePriceInOrderDetail(selectedOrder, detail)"
              (keyup)="onChangePriceInOrderDetail(selectedOrder, detail)" />
          </mat-form-field>
          } @else {
          <span [style.textDecoration]="
                detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
              " [style.textDecorationColor]="
                detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
              ">
            {{ detail?.unitPrice | decimalFormat }}
          </span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="subTotal">
        <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before"
          class="px-6 text-left first-col table-tittle">
          SubTotal
        </th>
        <td mat-cell *matCellDef="let detail" class="px-6 first-col table-text text-right">
          <span [style.textDecoration]="
              detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
            " [style.textDecorationColor]="
              detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
            ">
            {{ detail?.subTotal | decimalFormat }}
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="totalSurcharges">
        <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before"
          class="px-6 text-left first-col table-tittle">
          Recargo
        </th>
        <td mat-cell *matCellDef="let detail" class="px-6 first-col table-text text-right">
          <span [style.textDecoration]="
              detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
            " [style.textDecorationColor]="
              detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
            ">
            {{ detail?.totalSurcharges | decimalFormat }}
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="totalDiscounts">
        <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before"
          class="px-6 text-left first-col table-tittle">
          Descuento
        </th>
        <td mat-cell *matCellDef="let detail" class="px-6 first-col table-text text-right">
          <span [style.textDecoration]="
              detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
            " [style.textDecorationColor]="
              detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
            ">
            {{ detail?.totalDiscounts | decimalFormat }}
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="tax">
        <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before"
          class="px-6 text-left first-col table-tittle">
          Impuesto
        </th>
        <td mat-cell *matCellDef="let detail" class="px-6 first-col table-text text-right">
          <span [style.textDecoration]="
              detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
            " [style.textDecorationColor]="
              detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
            ">
            {{ detail?.totalTaxes | decimalFormat }}
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="total">
        <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before"
          class="px-6 text-left first-col table-tittle">
          <p class="pr-6">Total</p>
        </th>
        <td mat-cell *matCellDef="let detail" class="px-6 first-col table-text text-right">
          <span class="pr-6" [style.textDecoration]="
              detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
            " [style.textDecorationColor]="
              detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
            ">
            {{ detail?.total | decimalFormat }}
          </span>
        </td>
      </ng-container>

      <!-- Header Row -->
      <tr mat-header-row *matHeaderRowDef="displayColumsDistributionItems" class="bg-gray-100 dark:bg-gray-900"></tr>
      <!-- Fila principal -->
      <tr mat-row *matRowDef="let row; columns: displayColumsDistributionItems" class="border-b"></tr>
    </table>
  </div>
  <div *ngIf="this.dataSourceDistributionItemDetail.data.length === 0" class="border-t p-6 text-center text-1xl sm:p-4">
    @if(showButton){
    <button mat-raised-button color="primary" (click)="openSoldToEmptyDocument()"> Agregar
    </button>
    }
  </div>
</ng-template>
<!-- Confirmar modificaciones -->

<ng-template #updateDialog let-data>
  <div class="flex items-start space-x-2 m-4">
    <div class="flex items-center">
      <mat-icon class="text-amber-500 ml-4 mt-6" style="font-size: 32px">warning_amber</mat-icon>
    </div>
    <div class="grid">
      <h2 mat-dialog-title class="text-lg font-bold mb-1">
        {{ data.title }}
      </h2>
      <mat-dialog-content class="modal-content mt-0">
        <p>{{ data.description }}</p>
      </mat-dialog-content>
    </div>
  </div>
  <mat-dialog-actions class="modal-actions flex justify-end">
    <button mat-button mat-dialog-close class="align-left mr-3" [mat-dialog-close]="false">
      No
    </button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">
      Si
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #viewDocumentModal let-data>
  <h2 mat-dialog-title class="text-lg font-bold mb-1">
    Documento <span class="text-semibold">{{ data.serial }}</span>
  </h2>
  <mat-dialog-content class="modal-content-update">
    <app-order-list-table [dataList]="detailOrderUnified">
    </app-order-list-table>
  </mat-dialog-content>
  <mat-dialog-actions class="modal-actions flex justify-end">
    <button mat-raised-button color="primary" [mat-dialog-close]="true">
      Cerrar
    </button>
  </mat-dialog-actions>
</ng-template>


<ng-template #soldToEmptyDocument>
  <h2 mat-dialog-title class="text-lg font-bold mb-1">
    Seleccionar cliente
  </h2>
  <mat-dialog-content class="modal-content-update">
    @if(soldToList?.length > 0){
    <div class="flex flex-col">
      <mat-form-field appearance="fill" class="w-full" floatLabel="never">
        <mat-label>Cliente</mat-label>
        <mat-select [(ngModel)]="selectedSoldTo" name="soldTo">
          @for (soldTo of soldToList; track soldTo) {
          <mat-option [value]="soldTo">
            <div class="flex flex-col">
              <span class="text-sm font-semibold">{{ soldTo.soldTo?.externalKeys?.code }}</span>
              <div class="flex items-center gap-1">
                <span class="font-medium">{{ soldTo.soldTo?.name }} - {{ soldTo.serial }}</span>
              </div>
            </div>

          </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Unidad de medida</mat-label>
        <mat-select [(ngModel)]="detail.selectedUnit" name="selectedUnitSoldTo" (click)="$event.stopPropagation()">
          <mat-option [ngValue]="null" disabled selected>Selecciona una unidad</mat-option>
          <mat-option value="UMB">UMB</mat-option>
          @if(UMPActive){
          <mat-option value="UMP">UMP</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Cantidad</mat-label>
        <input matInput type="text" step="0.001" min="0" name="baseQuantity" placeholder="Cantidad" class="text-sm"
          [ngModel]="detail.selectedUnit == UnitOfMeasureEnum.UMB ? detail.baseQuantity : detail.pararellQuantity"
          (ngModelChange)="validateInput($event, detail)" (click)="$event.stopPropagation()" />
      </mat-form-field>
    </div>
    }@else{
    <p class="text-gray-500 items-center">No hay clientes disponibles</p>
    }
  </mat-dialog-content>
  <mat-dialog-actions class="modal-actions flex justify-between">
    <button mat-button mat-dialog-close class="align-left mr-3">
      Cancelar
    </button>
    <button mat-raised-button color="primary" (click)="saveSoldTo()">
      Guardar
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #documentbyMaterial>
  <app-work-progress-material-summary [materialData]="workProgressMaterialData"
    [isLoading]="isLoadingWorkProgressMaterials" [UMPActive$]="UMPActive$" (initComponent)="onWorkProgressMaterialsInit()">
  </app-work-progress-material-summary>
</ng-template>